import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { uniq } from 'ramda';
import { BusinessCollectionCompType } from '../../../../../Types/ObjektVy';
import AttributGrupp from '../../../_Common/Components/BusinessCollectionComponents/AttributGrupp/AttributGrupp';
import { collectionCompToObjektVy } from '../../../_Common/Components/BusinessCollectionComponents/BusinessCollectionUtils';
import BusinessDataForm, {
  ActionTransformer,
  BusinessDataFormContext,
  IBusinessDataFormContext,
  IBusinessDataFormState,
} from '../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import ObjektVy from '../../../_Common/Components/BusinessCollectionComponents/ObjektVy/ObjektVy';
import ObjektVySida from '../../../_Common/Components/BusinessCollectionComponents/ObjektVySida/ObjektVySida';
import {
  AktivitetQuery as IAktivitetQuery,
  AktivitetQuery_node_TEDBOAktivitet as IAktivitetNode,
  AktivitetQueryVariables as IAktivitetVariables,
  AktivitetQuery_node_TEDBOAktivitet__Associations as IAktivitetAssociations,
  AktivitetQuery_node_TEDBOAktivitet__Associations_AktBokRubrik,
  AktivitetQuery_node_TEDBOAktivitet__Associations_Handelsetyper_All,
  AktivitetQuery_node_TEDBOAktivitet__Associations_Amnesomraden_All,
} from './Queries/_QueryTypes/AktivitetQuery';
import AddMutation from './Mutations/AktivitetAddMutation.gql';
import {
  AktivitetAddMutation as IAddMutation,
  AktivitetAddMutationVariables as IAddMutationVariables,
} from './Mutations/_QueryTypes/AktivitetAddMutation';
import UpdateMutation from './Mutations/AktivitetUpdateMutation.gql';
import AktivitetQuery from './Queries/AktivitetQuery.gql';
import {
  AktivitetUpdateMutation as IUpdateMutation,
  AktivitetUpdateMutationVariables as IUpdateMutationVariables,
} from './Mutations/_QueryTypes/AktivitetUpdateMutation';
import { QueryHookOptions, useMutation, useQuery } from '@apollo/client';
import { useCollectionMutation } from '../../../../../Components/QueryComponents/CollectionMutation/useCollectionMutation';
import { ActiveDatabaseContext } from '../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import { useSelectedDetailQuery } from '../../../../../Components/QueryComponents/SelectedDetailQuery/useSelectedDetailQuery';
import {
  defaultEditMenuCancelButton,
  defaultEditMenuSaveAndCloseButton,
  defaultEditMenuSaveButton,
  getFieldValidationInfo,
  IEditMenuAction,
  IEditMenuActionParams,
  IFieldValidations,
  IFormData,
  IValidateFn,
  removeIdsFromNewAssociations,
} from '../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import clientAvenyModel from '../../../../../Model/clientAvenyModel';
import { IClientBusinessModel } from '../../../../../Types/ClientModelTypes';
import {
  TEDInputBOAktivitetAddValues,
  TEDBOAktivitetTypEnum,
} from '../../../../../globalQueryTypes';
import { GridContext } from '../../../../GridContext';
import { ObjektVyKortDel } from '../../../_Common/Components/BusinessCollectionComponents/ObjektVyKort/ObjektVyKortDel';
import Attribut from '../../../_Common/Components/BusinessCollectionComponents/Attribut/Attribut';
import { ThemeProvider } from '@emotion/react';
import { StyledEngineProvider, useTheme } from '@mui/material';
import AvenyTheme, {
  AvenyThemeDark,
} from '../../../../../BaseComponents/ThemeProvider/AvenyTheme';
import Dialog from '../../../../../BaseComponents/Dialog/EDDialog';
import EDTypography from '../../../../../BaseComponents/Typography/EDTypography';
import { aktivitetColors, themeColor } from '../../Utils/AktivitetTheme';
import { ObjektVyKort } from '../../../_Common/Components/BusinessCollectionComponents/ObjektVyKort/ObjektVyKort';
import { ObjektLank } from '../../../_Common/Components/BusinessCollectionComponents/ObjektLank/ObjektLank';
import ObjektVyKolumner, {
  ObjektVyKolumn,
} from '../../../_Common/Components/BusinessCollectionComponents/ObjektVyKolumner/ObjektVyKolumner';
import {
  AssociationList,
  IAssociationListConfig,
} from '../../../_Common/Components/BusinessCollectionComponents/AssociationList/AssociationList';
import AktivitetResursValjare, {
  ICurrentDayBooking,
} from './AktivitetResursValjare';
import { ModelContext } from '../../../../../Model/ModelContext/ModelContext';
import { attributeValueDisplayText } from '../../../../../Components/Attributes/Utils/AttributeValueUtils';
import { BusinessDataFormAction } from '../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import AssociatedActivitiesQuery from '../../Rutiner/Kalender/Queries/AssociatedActivitiesQuery/AssociatedActivitiesQuery.gql';
import { selectedId } from '../../../../../Components/MasterDetail/MasterDetailUtils';
import { StatistikrapporteringCard } from '../Statistikrapportering/StatistikrapporteringCard';
import EDCaptionedValue from '../../../../../BaseComponents/CaptionedValue/EDCaptionedValue';
import AttributeDisplayText from '../../../../../Components/Attributes/AttributeDisplayText/AttributeDisplayText';
import { getAttributeInfo } from '../../../../../Model/avenyModelUtils';
import EDColumns, {
  EDColumn,
} from '../../../../../BaseComponents/Columns/EDColumns';
import EDBox from '../../../../../BaseComponents/EDBox/EDBox';
import { useProgramoption } from '../../../../../Hooks/useProgramoptions';
import { VisningsTypContext } from '../../../_Common/Components/BusinessCollectionComponents/VisningsTypContext/VisningsTypContext';
import {
  addCustomActivityFunctionMenuItem,
  getGruppUrval,
  getVarmeOption,
  isReadOnlyRutin,
  IVarmeOption,
  modifyUpdateResTimeAction,
  overlappedBookings,
  userCanEditBooking,
  varmeHelperText,
  varmeInstallningarOptions,
  varmeWarning,
} from './Utils/AktivitetUtils';
import { defaultBusinessCollectionMenuItem } from '../../../_Common/Components/BusinessCollectionComponents/BusinessCollectionMenu/Utils/BusinessCollectionMenuUtils';
import {
  MeQuery,
  MeQueryVariables,
} from '../../Rutiner/Kalender/Queries/MeQuery/_QueryTypes/MeQuery';
import meQuery from '../../Rutiner/Kalender/Queries/MeQuery/MeQuery.gql';
import { tryDateToDateString } from '../../../../../Utils/dateUtils';
import { LoginStateContext } from '../../../../Login/Contexts/LoginStateContext/LoginStateContext';
import RepeteraAktivitetDialog from './Components/RepeteraAktivitetDialog/RepeteraAktivitetDialog';
import mergeSort, { stringCompare } from '../../../../../Utils/mergeSort';
import { ViewDbSettingsContext } from '../../Rutiner/Kalender/Components/SchedulerComponent/ViewDbSettingsContext';
import {
  IAktTypResursRubrik,
  ResursTypContext,
  ResursTypContextProvider,
} from '../../Contexts/ResursTypContext/ResursTypContext';
import UpdateRepeteraAktivitet from './Components/UpdateRepeteraAktivitet/UpdateRepeteraAktivitet';
import { DubbelbokningsvarningDialog } from './Components/DubbelbokningsvarningDialog/DubbelbokningsvarningDialog';
import EDCheckbox from '../../../../../BaseComponents/Checkboxes/EDCheckbox';
import {
  HandelsetypQuery,
  HandelsetypQueryVariables,
} from './Queries/_QueryTypes/HandelsetypQuery';
import handelsetypQuery from './Queries/HandelsetypQuery.gql';
import {
  AmnesomradenQuery,
  AmnesomradenQueryVariables,
} from './Queries/_QueryTypes/AmnesomradenQuery';
import amensomradenQuery from './Queries/AmnesomradenQuery.gql';
import { FormUpdateAssociatonType } from '../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormValueUtils';
import { NEWLY_ADDED_ID_PREFIX_FOR_UPDATE } from '../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Const/BusinessDataFormConst';
import {
  useIsExtraSmallScreen,
  useIsSmallScreen,
} from '../../../../../Hooks/useFullscreenView';
import {
  AktivitetDateTimeFormatter,
  combineDateAndTime,
} from './Utils/AktivitetDateTimeFormatter';
import { EDAutoCompleteEdit } from '../../../../../BaseComponents/AutoCompleteEdit/EDAutoCompleteEdit';
import { EDCounter } from '../../../../../BaseComponents/Counter/EDCounter';
import EDExpansionPanel from '../../../../../BaseComponents/Accordion/EDExpansionPanel';
import {
  GetResursDoubleBookingQuery,
  GetResursDoubleBookingQueryVariables,
} from './Queries/_QueryTypes/GetResursDoubleBookingQuery';
import resursDoubleBookingQuery from './Queries/GetResursDoubleBookingQuery.gql';
import {
  BOGetXBridgeBookingsQuery,
  BOGetXBridgeBookingsQueryVariables,
} from '../../Rutiner/Kalender/Queries/XbridgeQuery/_QueryTypes/BOGetXBridgeBookingsQuery';
import optionQuery from './Queries/KravVerksamhetstypOptionQuery.gql';
import {
  KravVerksamhetstypOptionQuery,
  KravVerksamhetstypOptionQueryVariables,
} from './Queries/_QueryTypes/KravVerksamhetstypOptionQuery';
import xbridgeQuery from '../../Rutiner/Kalender/Queries/XbridgeQuery/BOGetXBridgeBookings.gql';
import { RutinSettingsContext } from '../../../_Common/Components/RutinAvailabilityContext/RutinAvailabilityContext';
import { rutinInfos } from '../../../_Common/Const/RutinInfo';
import EDButton from '../../../../../BaseComponents/Buttons/Button/EDButton';
import EDIcon from '../../../../../BaseComponents/Icon/EDIcon';
import { ResursAvvikandeTid } from './ResursAvvikandeTid';
import { dateToStr } from '../../../../../Utils/stringUtils';
import { useDeleteFunctionMenuItem } from '../../../../../Hooks/useDeleteItem';
import { useBusinessConfig } from '../../../../../Components/BusinessConfigContext/BusinessConfigContext';
import { BevakningDialog } from './Components/BevakningDialog';
import { getUseAktivitetFunktionsMenyItems } from './UseAktivitetFunktionsMenyItems';
import AvlidenInfo from './Components/AktivitetInfo';
import { VerksamhetstypSelect } from './Components/VerksamhetstypSelect/VerksamhetstypSelect';
import {
  ActivityIcons,
  hasActivityIcons,
} from '../../Rutiner/Kalender/Components/SchedulerComponent/Utils/ActivityIconsSelector';
import {
  validateAktivitet,
  validateGudstjanstTyp,
  validateMinimumResources,
} from './Utils/AktivitetValidation';
import DeleteRepeteradeAktivitetDialog from './Components/DeleteRepeteradeAktivitetDialog/DeleteRepeteradeAktivitetDialog';
import CopyActivityDialog from './Components/CopyActivityDialog/CopyActivityDialog';
import EDAvenyProgress from '../../../../../BaseComponents/ProgressIndicators/AvenyProgress/EDAvenyProgress';

interface IXBridgeDubbelbokCheckProps {
  activeDatabase: string | null;
  routineID: number | undefined;
  formContext: IBusinessDataFormContext;
}

// TODO: bryt ut XBridgeDubbelbokCheck till en egen fil
const XBridgeDubbelbokCheck: React.FC<
  React.PropsWithChildren<IXBridgeDubbelbokCheckProps>
> = props => {
  const currentValues = props.formContext?.formState?.currentValues;

  const resursKoder =
    currentValues?._Associations?.AktBokRubrik?.map(
      (rub: any) => rub._Associations?.Resurs?.BO_RESURS_ID
    ).join(';') ?? '';

  const activeDatabase = props.activeDatabase ?? '';
  const routineID = props.routineID ?? '';
  const frandatum = currentValues?.['FRANDATUM'] ?? '';
  const tilldatum = currentValues?.['TILLDATUM'] ?? '';

  const xbridgeQueryOption = useMemo<
    QueryHookOptions<
      BOGetXBridgeBookingsQuery,
      BOGetXBridgeBookingsQueryVariables
    >
  >(
    () => ({
      variables: {
        dbname: activeDatabase,
        startdatum: frandatum,
        slutdatum: tilldatum,
        resursId: resursKoder.split(';'),
      },
      skip:
        !activeDatabase ||
        !routineID ||
        !frandatum ||
        !tilldatum ||
        resursKoder.length === 0,
      fetchPolicy: 'network-only',
    }),
    [activeDatabase, routineID, frandatum, tilldatum, resursKoder] // Include currentValues here if necessary
  );
  const {
    data: double_booking_xbridge_data,
    loading: double_booking_xbridge_loading,
  } = useQuery<BOGetXBridgeBookingsQuery, BOGetXBridgeBookingsQueryVariables>(
    xbridgeQuery,
    xbridgeQueryOption
  );
  const formStateDispatch = props.formContext?.formStateDispatch;
  useEffect(() => {
    if (!double_booking_xbridge_loading) {
      const currentDayXbridgeBookings: ICurrentDayBooking[] =
        double_booking_xbridge_data?.rtn?.BOGetXBridgeBookings?.map(item => ({
          aktId: 'Outlook',
          BO_RESURS_ID: item.resursId ?? '',
          resStart: item.startdatum ?? '',
          resEnd: item.slutdatum ?? '',
          bokNr: '',
          aktTitel: item.titel ?? '',
        })) ?? [];

      formStateDispatch?.({
        type: 'UPDATE',
        customValues: {
          currentDayXbridgeBookings: currentDayXbridgeBookings,
        },
        ignoreFormHasChanged: true,
        value: {},
      });
    }
  }, [
    double_booking_xbridge_data,
    double_booking_xbridge_loading,
    formStateDispatch,
  ]);

  return <>{props.children}</>;
};

const aktivitetModel: IClientBusinessModel =
  clientAvenyModel.BO.BusinessModels.BOAktivitet;

interface ICustomid {
  id: string;
  customDetailData: string;
}
export const AktivitetVy: BusinessCollectionCompType = props => {
  const databaseContext = useContext(ActiveDatabaseContext);
  const availableRoutines = databaseContext.availableRoutines;
  const [dialogOpen, setDialogOpen] = useState(false);
  const [showCopyActivity, setShowCopyActivity] = useState(false);
  const { activeDatabase } = useContext(ActiveDatabaseContext);
  const { avenyCollectionMap } = useContext(ModelContext);
  const visningsTypContext = useContext(VisningsTypContext);
  const viewDbSettingsContext = useContext(ViewDbSettingsContext);
  const resursTypContext = useContext(ResursTypContext);
  const [openUpdateRepeteraDialog, setOpenUpdateRepeteraDialog] =
    useState(false);

  const [isOverlappedAndRepeated, setIsOverlappedAndReapeated] =
    useState(false);
  const isExtraSmallScreen = useIsExtraSmallScreen();
  const [
    resourceDoubleBookedSingleAktivityView,
    setResourceDoubleBookedSingleAktivityView,
  ] = useState<null | 'save' | 'saveAndClose'>(null);
  const [saveAndCloseUpdate, setSaveAndCloseUpdate] = useState(false);

  const isExtraSmall = useIsExtraSmallScreen();
  const isSmall = useIsSmallScreen();
  const [franDatum, setFranDatum] = useState('');
  const [tillDatum, setTillDatum] = useState('');
  const [resursLista, setResursLista] = useState<string[]>([]);
  const [deviatingTimeOpen, setDeviatingTimeOpen] = useState(false);
  const [openPremity, setOpenPremity] = useState<boolean>(false);
  const [
    openDeleteRepeteradeAktivitetDialog,
    setOpenDeleteRepeteradeAktivitetDialog,
  ] = useState<boolean>(false);
  const [openBevakning, setOpenBevakning] = useState(false);
  const [approvedDoubleBookings, setApprovedDoubleBookings] = useState<
    Array<{
      resursId: string;
      startTime: string;
      endTime: string;
    }>
  >([]);
  const [openClearNoteDialog, setOpenClearNoteDialog] = useState(false);
  const [fieldToClear, setFieldToClear] = useState<
    'BESKRIVNING' | 'NOTERING2' | null
  >(null);

  const {
    nodeData,
    loading: nodeLoading,
    refetch: nodeRefetch,
  } = useSelectedDetailQuery<
    IAktivitetQuery,
    IAktivitetNode,
    IAktivitetVariables
  >(AktivitetQuery, props.id);

  const loginStateContext = useContext(LoginStateContext);
  const routineAvailabilityContext = useContext(RutinSettingsContext);
  const routineID = routineAvailabilityContext.activeRoutine?.routine.rutinID;
  const selectOther = props.selectOther;

  const activeDatabaseOptions = useMemo(
    () => ({
      variables: {
        dbname: activeDatabase ?? 'noDBYet',
      },
      skip: !activeDatabase,
    }),
    [activeDatabase]
  );

  const { data: me_data } = useQuery<MeQuery, MeQueryVariables>(
    meQuery,
    activeDatabaseOptions
  );

  let userCanEditOvrigAktGudsAktOchNoteringBooking = userCanEditBooking(
    nodeData,
    me_data?.me?.[0]
  );

  const dokConfig: IAssociationListConfig = useMemo(
    () => ({
      inCard: true,
      defaultVisningstyp: 'lista',
      businessCollectionMenuItems: [
        {
          ...defaultBusinessCollectionMenuItem.Add,
          isDisabled: !userCanEditOvrigAktGudsAktOchNoteringBooking,
        },
      ],
      showDeleteIcon: true,
      disableAddRefetchButtonQuery: true,
    }),
    [userCanEditOvrigAktGudsAktOchNoteringBooking]
  );

  const { data: amnesomraden } = useQuery<
    AmnesomradenQuery,
    AmnesomradenQueryVariables
  >(amensomradenQuery, activeDatabaseOptions);

  const { data: handelsetyp_data } = useQuery<
    HandelsetypQuery,
    HandelsetypQueryVariables
  >(handelsetypQuery, activeDatabaseOptions);

  const { data: kravVerksamhetstyp } = useQuery<
    KravVerksamhetstypOptionQuery,
    KravVerksamhetstypOptionQueryVariables
  >(optionQuery, {
    variables: {
      dbName: activeDatabase ?? '',
    },
    fetchPolicy: 'network-only',
  });

  const sysOptionKravVerksamhetstyp =
    kravVerksamhetstyp?.db?.SYSOptions_All?.find(
      option => option.OptionKey === 'SYS_KRAVVERKSAMHETSTYP_WEBAVENY'
    )?.OptionData === 'Y';

  const allAktResursRubriker: IAktTypResursRubrik[] | undefined = useMemo(
    () =>
      nodeData
        ? nodeData._Associations?.AktResrubrik?.map(resrub => ({
            id: nodeData.id,
            posNr: resrub.POSNR ?? 0,
            foreslagenResTyp:
              resrub._Associations?.Resrubrik?.ForeslResTyp ?? '',
            tillatenResTyp: resrub._Associations?.Resrubrik?.TillResTyp ?? '',
          })) || []
        : undefined,
    [nodeData]
  );

  // Repeterade Aktiviteter visa bantad lista.
  const customrepCols = useMemo<IAssociationListConfig>(() => {
    return {
      defaultVisningstyp: 'tabell',
      inCard: true,
      customDefaultColumns: [
        { attributeDef: 'TITEL', caption: 'Titel', header: true },
        { attributeDef: '_typ', caption: 'Aktivitetstyp' },
        { attributeDef: 'FRANDATUM', caption: 'Fråndatum' },
        { attributeDef: 'FRANTID', caption: 'Från kl' },
        { attributeDef: 'Resurs1.RESURS_NAMN', caption: 'Plats' },
        { attributeDef: 'BOKNINGSNUMMER', caption: 'BokNr' },
      ],
      objectLinksEnabled: true,
      // function to handle repeated activities three dots menu separately
      useFunctionMenuItems: input => {
        let baseUrl = window.location.href;
        baseUrl = baseUrl.substring(0, baseUrl.lastIndexOf('/'));
        // let baseUrl = baseUrlParts.slice(0, 10).join('/');

        if (baseUrl.slice(-1) !== '/') {
          baseUrl = `${baseUrl}/`;
        }
        const url = `${baseUrl}${input.id}/`;

        const businessConfig = useBusinessConfig(
          input.collection?.CollectionName
        );

        return [
          {
            id: 'Öppna i ny flik',
            caption: 'Öppna i ny flik',
            onClick: () => {
              if (input.collection) {
                window.open(url, '_blank');
              }
            },
            iconType: 'open_in_new',
          },
          useDeleteFunctionMenuItem(input, businessConfig),
        ];
      },
      hideDefaultFunktionsMenyItems: true,
    };
  }, []);

  const [addMutation, addStatus] = useMutation<
    IAddMutation,
    IAddMutationVariables
  >(AddMutation, {
    refetchQueries: ['collection'],
  });

  const [updateMutation, { loading, error }] = useCollectionMutation<
    IUpdateMutation,
    IUpdateMutationVariables
  >(UpdateMutation);

  const värmestyrning = useProgramoption('VarmeStyrning', activeDatabase);

  const activeDatabaseContext = useContext(ActiveDatabaseContext);
  const publicering =
    activeDatabaseContext.availableRoutines?.[
      rutinInfos.rtnWebPubliceringsInstExtern.rutinID
    ]?.readonly == false ||
    activeDatabaseContext.availableRoutines?.[
      rutinInfos.rtnWebPubliceringsInstIntern.rutinID
    ]?.readonly == false;

  const addFunction = useCallback(
    (values: IFormData) => {
      return addMutation({
        variables: {
          db: activeDatabase || '',
          values: {
            ...values,
            _typ: values._typ ? values._typ : TEDBOAktivitetTypEnum.AKTOVRIGT,
            BOKNINGSSIGNATUR: loginStateContext.sign,
            BOKNINGSDATUM: tryDateToDateString(new Date()),
          } as TEDInputBOAktivitetAddValues,
        },
        refetchQueries: ['rtnWebKalenderMain'],
      });
    },
    [activeDatabase, addMutation, loginStateContext.sign]
  );

  const updateFunction = useCallback(
    (values: IFormData) => {
      const newValues = removeIdsFromNewAssociations(values ?? {});
      return updateMutation({
        variables: {
          db: activeDatabase || '',
          values: {
            id: nodeData?.id ?? '',
            ...newValues,
            _version: nodeData?._version ?? 1,
          },
        },
        refetchQueries: () => {
          const bookingId = props.config?.parents?.find(
            parent => parent.associationName === 'Aktivitet'
          )?.id;

          if (bookingId) {
            return [
              {
                query: AssociatedActivitiesQuery,
                variables: {
                  id: selectedId(bookingId),
                },
              },
              'rtnWebKalenderMain',
            ];
          } else {
            return ['rtnWebKalenderMain'];
          }
        },
      });
    },
    [
      updateMutation,
      activeDatabase,
      nodeData?.id,
      nodeData?._version,
      props.config?.parents,
    ]
  );
  // ↓↓ useCallback with functions to prevent the function from running everytime ↓↓
  const formStateActionTransformer = useCallback(
    (
      action: Readonly<BusinessDataFormAction>,
      formState: IBusinessDataFormState
    ): BusinessDataFormAction => {
      switch (action.type) {
        case 'UPDATE':
          {
            // State-variabler för dubbelbokningsvarning
            // FIXME: Lös på bättre sätt (GR)
            if (action.value.FRANDATUM) {
              action.value.TILLDATUM = action.value.FRANDATUM;
              setFranDatum(action.value.FRANDATUM);
            }
            if (action.value.TILLDATUM) {
              setTillDatum(action.value.TILLDATUM);
            }
            if (action.value?._Associations?.AktBokRubrik_Add_Values) {
              const addedResursKoder =
                action.value?._Associations?.AktBokRubrik_Add_Values.map(
                  (addRub: any) =>
                    addRub._Associations?.Resurs_Ref?.BO_RESURS_ID
                );
              const nyResursLista = resursLista.concat(addedResursKoder);
              setResursLista(nyResursLista);
            }
            if (action.value?._Associations?.AktBokRubrik_Delete_Values) {
              const deletedResursKoder: string[] =
                action.value?._Associations?.AktBokRubrik_Delete_Values.map(
                  (delRub: any) =>
                    formState.currentValues?._Associations?.AktBokRubrik?.find(
                      (
                        rub: AktivitetQuery_node_TEDBOAktivitet__Associations_AktBokRubrik
                      ) => rub.id === delRub.id
                    )?._Associations?.Resurs?.BO_RESURS_ID ?? ''
                ) ?? [];
              const nyResursLista = resursLista.filter(
                res =>
                  deletedResursKoder.findIndex(delRes => delRes === res) < 0
              );
              setResursLista(nyResursLista);
            }

            // Övriga verksamhetsregler
            if (
              action.value &&
              action?.value?._Associations &&
              action?.value?._Associations.Verksamhetstyp_Ref !== undefined
            ) {
              action.value._Associations.OpGrupp_Ref = null;
            }
            // if the booking title is blank or equal to the old Verksamhetstyp then set the new Verksamhetstyp
            if (
              action.value._Associations?.Verksamhetstyp_Ref &&
              (formState?.currentValues?.TITEL === '' ||
                formState?.currentValues?.TITEL ===
                  formState?.currentValues?._Associations?.Verksamhetstyp
                    ?.BENAMNING)
            ) {
              action.value['TITEL'] =
                action.value._Associations?.Verksamhetstyp_Ref?.BENAMNING;
            }
            // if the booking title is blank or equal to the old GudstjanstTyp then set the new GudstjanstTyp
            if (
              action.value._Associations?.GudstjanstTyp_Ref &&
              (formState?.currentValues?.TITEL === '' ||
                formState?.currentValues?.TITEL ===
                  formState?.currentValues?._Associations?.GudstjanstTyp
                    ?.NYTT_NAMN)
            ) {
              action.value['TITEL'] =
                action.value._Associations?.GudstjanstTyp_Ref.NYTT_NAMN;
            }
            // If Bokningsgrupp is changed, clear bookings
            if (
              formState?.values?._Associations &&
              action.value &&
              action?.value?._Associations &&
              action?.value?._Associations.Bokningsgrupp_Ref !== undefined
            ) {
              formState.values._Associations.AktBokRubrik_Add_Values = null;
              if (formState?.values?._Associations?.Verksamhetstyp_Ref) {
                formState.values._Associations.Verksamhetstyp_Ref = null;
              }
            }
            // If booking time changes, update resources to match
            modifyUpdateResTimeAction(action, formState, 'FRANDATUM');
            modifyUpdateResTimeAction(action, formState, 'TILLDATUM');
            modifyUpdateResTimeAction(action, formState, 'FRANTID');
            modifyUpdateResTimeAction(action, formState, 'TILLTID');
          }
          break;
        case 'LOAD_INITIAL_VALUE':
          {
            // State-variabler för dubbelbokningsvarning
            if (action.initialValue?.['FRANDATUM']) {
              setFranDatum(action.initialValue?.['FRANDATUM']);
            }
            if (action.initialValue?.['TILLDATUM']) {
              setTillDatum(action.initialValue?.['TILLDATUM']);
            }

            if (
              (
                action.initialValue?._Associations as unknown as Record<
                  string,
                  unknown
                >
              )?.['AktBokRubrik_Add_Values']
            ) {
              const resursKoder = (
                (
                  action.initialValue?._Associations as unknown as Record<
                    string,
                    unknown
                  >
                )['AktBokRubrik_Add_Values'] as Array<{
                  _Associations?: { Resurs_Ref?: { BO_RESURS_ID?: string } };
                }>
              )
                .map(rub => rub._Associations?.Resurs_Ref?.BO_RESURS_ID)
                .filter((id): id is string => id !== undefined);
              setResursLista(resursKoder);
            }
          }
          break;
        case 'LOAD_DATA':
          {
            // State-variabler för dubbelbokningsvarning
            if (action.data?.['FRANDATUM']) {
              setFranDatum(action.data?.['FRANDATUM']);
            }
            if (action.data?.['TILLDATUM']) {
              setTillDatum(action.data?.['TILLDATUM']);
            }
            if (action.data?._Associations?.AktBokRubrik) {
              const resursKoder = action.data?._Associations?.AktBokRubrik.map(
                (
                  rub: AktivitetQuery_node_TEDBOAktivitet__Associations_AktBokRubrik
                ) => rub._Associations?.Resurs?.BO_RESURS_ID
              );
              setResursLista(resursKoder);
            }
          }
          break;
      }
      return action;
    },
    [resursLista]
  );

  const defaultFunctionMenu = getUseAktivitetFunktionsMenyItems(true)({
    id: selectedId(props.id),
    collection: aktivitetModel,
    item: nodeData,
    me_data: me_data,
  });

  const attrInfoStatistikStatus = getAttributeInfo(
    aktivitetModel,
    'StatistikStatus',
    avenyCollectionMap
  );

  // ↓↓ Repeat activity button in the lower bar that only shows within calender and triggers the repeat component ↓↓

  const repeteraAktivitetButton: IEditMenuAction = {
    id: 'repetera_dialog',
    label: 'Repetera',
    onClick: () => {
      setDialogOpen(true);
    },
    isDisabled: ({ businessDataFormContext }) => {
      let disabledReason = null;

      if (nodeLoading) {
        disabledReason = 'Laddar';
      }

      if (
        !businessDataFormContext?.formState?.currentValues?.['id'] ||
        businessDataFormContext.formState.formHasChanged
      ) {
        disabledReason = 'Aktiviteten måste sparas innan den repeteras';
      }

      if (businessDataFormContext.mutationLoading) {
        disabledReason = 'Laddar';
      }

      if (
        businessDataFormContext?.formState.currentValues
          ?.AntalRepeteradeAktiviteter &&
        businessDataFormContext?.formState.currentValues
          ?.AntalRepeteradeAktiviteter > 0
      ) {
        disabledReason = 'Aktiviteten är redan repeterad';
      }

      if (
        (nodeData?._typ !== 'AKTOVRIGT' && nodeData?._typ !== 'GUDSTJANST') ||
        !userCanEditOvrigAktGudsAktOchNoteringBooking
      ) {
        disabledReason = 'Aktiviteten går inte att repetera';
      }

      if (isReadOnlyRutin('rtnWebKalender', availableRoutines)) {
        disabledReason = 'Du är inte behörig att redigera denna aktivitet';
      }

      if (disabledReason) {
        return disabledReason;
      }

      return false;
    },
    flat: true,
    icon: 'repeated_event',
    hideIconIfNotFloating: true,
  };

  const copyAktivityButton: IEditMenuAction = {
    id: 'kopiera_dialog',
    label: 'Kopiera',
    onClick: () => {
      setShowCopyActivity(true);
    },
    isDisabled: ({ businessDataFormContext }) => {
      let disabledReason = null;

      if (nodeLoading) {
        disabledReason = 'Laddar';
      }

      if (
        !businessDataFormContext?.formState?.currentValues?.['id'] ||
        businessDataFormContext.formState.formHasChanged
      ) {
        disabledReason = 'Aktiviteten måste sparas innan den kopieras';
      }

      if (businessDataFormContext.mutationLoading) {
        disabledReason = 'Laddar';
      }

      if (
        (nodeData?._typ !== 'AKTOVRIGT' && nodeData?._typ !== 'GUDSTJANST') ||
        !userCanEditOvrigAktGudsAktOchNoteringBooking
      ) {
        disabledReason = 'Aktiviteten går inte att kopiera';
      }

      if (isReadOnlyRutin('rtnWebKalender', availableRoutines)) {
        disabledReason = 'Du är inte behörig att kopiera denna aktivitet';
      }

      if (
        businessDataFormContext?.formState.currentValues
          ?.AntalRepeteradeAktiviteter &&
        businessDataFormContext?.formState.currentValues
          ?.AntalRepeteradeAktiviteter > 0
      ) {
        disabledReason = 'Repeterande aktiviteter kan inte kopieras';
      }

      if (disabledReason) {
        return disabledReason;
      }

      return false;
    },
    flat: true,
    icon: 'file_copy',
    hideIconIfNotFloating: true,
  };

  // ↓↓ useMemo here so that the function does not run more than once and hence empties the returned object ↓↓
  const initialValue = useMemo(() => {
    let activityType = (props.id as ICustomid).customDetailData;
    let init = viewDbSettingsContext.getNyAktivitetInitialValues?.() ?? {};
    init._typ = activityType;
    init.WEBBOKAD = 'Y';

    if (init._Associations === undefined) {
      init._Associations = {
        Bokningsgrupp_Ref: {
          id: me_data?.me?.[0].bokningsgrupper?.[0]?.id,
          BENAMNING: me_data?.me?.[0].bokningsgrupper?.[0]?.namn,
        },
      };
    }

    if (resursTypContext && init?._Associations?.AktBokRubrik_Add_Values) {
      // Håll koll på vilka rubrikpositioner som redan är tilldelade för att undvika dubbletter
      let usedPosnr: number[] = [];

      init._Associations.AktBokRubrik_Add_Values.forEach((aktbokrub: any) => {
        // Hämta rubriker för denna aktivitetstyp och sortera dem efter hur väl de matchar resurstypen
        const possibleAktTypResursRubriker = mergeSort(
          resursTypContext
            .aktTypRubriker(
              init._typ ?? 'NoType',
              init._Associations?.Bokningsgrupp_Ref?.id ?? 'NoID'
            )
            .map(rub => ({
              rubrik: rub,
              depth: resursTypContext.isOfType(
                aktbokrub?._Associations?.Resurs_Ref?._Associations
                  ?.ResRestyp_Ref?.BO_RESURSTYP_NAMN ?? 'NoType',
                rub.foreslagenResTyp
              ),
            }))
            .filter(rub => rub.depth > 0),
          (a, b) => a.depth - b.depth
        );

        // Sök efter första lediga rubrikposition som ännu inte är tilldelad till någon annan resurs
        const availableRubrik = possibleAktTypResursRubriker?.find(
          rub => !usedPosnr.includes(rub.rubrik.posNr)
        );

        // Om ledig rubrik finns, tilldela den till denna resurs
        if (availableRubrik) {
          aktbokrub.AKTRESRUB_POSNR = availableRubrik.rubrik.posNr;
          // Markera denna position som använd
          usedPosnr.push(availableRubrik.rubrik.posNr);
        }
      });
    }

    return init;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const theme = useTheme();

  const [aktivitetColor, prelAktivitetBackground] = aktivitetColors(
    nodeData?._typ,
    !!nodeData?.PRELBOKAD,
    false,
    theme
  );

  const FormattedDayTime = AktivitetDateTimeFormatter(
    nodeData?.FRANDATUM,
    nodeData?.TILLDATUM,
    nodeData?.FRANTID,
    nodeData?.TILLTID
  );

  // Hanterar rensning av noteringar
  const handleClearRequest = (field: 'BESKRIVNING' | 'NOTERING2') => {
    setFieldToClear(field);
    setOpenClearNoteDialog(true);
  };

  const queryFranDatum = nodeData?.FRANDATUM || franDatum;
  const queryTillDatum = nodeData?.TILLDATUM || tillDatum;

  const resursDoubleBookingQueryOptions = useMemo<
    QueryHookOptions<
      GetResursDoubleBookingQuery,
      GetResursDoubleBookingQueryVariables
    >
  >(
    () => ({
      variables: {
        dbname: activeDatabase ?? '',
        routineID: routineID,
        franDatum: queryFranDatum,
        tillDatum: queryTillDatum,
      },
      skip:
        !activeDatabase ||
        !routineID ||
        queryFranDatum === '' ||
        queryTillDatum === '',
      fetchPolicy: 'network-only',
    }),
    [activeDatabase, queryFranDatum, routineID, queryTillDatum]
  );
  const { data: double_booking_data } = useQuery<
    GetResursDoubleBookingQuery,
    GetResursDoubleBookingQueryVariables
  >(resursDoubleBookingQuery, resursDoubleBookingQueryOptions);

  const xbridgeQueryOption = useMemo<
    QueryHookOptions<
      BOGetXBridgeBookingsQuery,
      BOGetXBridgeBookingsQueryVariables
    >
  >(
    () => ({
      variables: {
        dbname: activeDatabase ?? '',
        startdatum: queryFranDatum,
        slutdatum: queryTillDatum,
        resursId: resursLista,
      },
      skip:
        !activeDatabase ||
        !routineID ||
        queryFranDatum === '' ||
        queryTillDatum === '' ||
        resursLista.length === 0,
      fetchPolicy: 'network-only',
    }),
    [activeDatabase, queryFranDatum, resursLista, routineID, queryTillDatum]
  );
  const { data: double_booking_xbridge_data } = useQuery<
    BOGetXBridgeBookingsQuery,
    BOGetXBridgeBookingsQueryVariables
  >(xbridgeQuery, xbridgeQueryOption);

  const currentDayBookings: ICurrentDayBooking[] =
    double_booking_data?.db?.BOBokningsrubrik_All?.map(item => ({
      aktId: item?._Associations?.Aktivitet?.id ?? '',
      BO_RESURS_ID: item?._Associations?.Resurs?.BO_RESURS_ID ?? '',
      resStart: combineDateAndTime(item?.FRANDATUM, item?.FRANTID),
      resEnd: combineDateAndTime(item?.TILLDATUM, item?.TILLTID),
      bokNr: item?._Associations?.Aktivitet?.BOKNINGSNUMMER ?? '',
      aktTitel: item?._Associations?.Aktivitet?.TITEL ?? '',
      varning_dubbelbokning: item?._Associations?.Resurs?.VARNING_DUBBELBOKNING,
    })) ?? [];

  const currentDayXbridgeBookings: ICurrentDayBooking[] =
    double_booking_xbridge_data?.rtn?.BOGetXBridgeBookings?.map(item => ({
      aktId: 'Outlook',
      BO_RESURS_ID: item.resursId ?? '',
      resStart: item.startdatum ?? '',
      resEnd: item.slutdatum ?? '',
      bokNr: '',
      aktTitel: item.titel ?? '',
    })) ?? [];

  const checkDubbelbokningarDefaultEditMenuSaveButton = (formContext: any) => {
    const date = new Date();
    const parseDate = dateToStr(date);
    const aktivitetDatum = formContext?.formState?.currentValues?.FRANDATUM;
    const overLapped = overlappedBookings(
      currentDayBookings,
      currentDayXbridgeBookings,
      formContext.formState?.currentValues
    );
    const overLappedChanged = overLapped.filter(
      bok =>
        formContext?.formState?.values?._Associations?.AktBokRubrik_Add_Values?.find(
          (added: any) => added.id === bok.rubrikId
        ) ||
        formContext?.formState?.values?._Associations?.AktBokRubrik_Update_Values?.find(
          (updated: any) => updated.id === bok.rubrikId
        )
    );
    const antalRepeteradeAktiviteter =
      formContext.formState?.currentValues?.AntalRepeteradeAktiviteter;

    if (
      overLappedChanged.length > 0 &&
      antalRepeteradeAktiviteter &&
      antalRepeteradeAktiviteter > 0
    ) {
      setResourceDoubleBookedSingleAktivityView('save');
      setIsOverlappedAndReapeated(true);
    }
    if (overLappedChanged.length > 0) {
      setResourceDoubleBookedSingleAktivityView('save');
      setOpenUpdateRepeteraDialog(false);
    }

    if (
      overLappedChanged.length <= 0 &&
      antalRepeteradeAktiviteter &&
      antalRepeteradeAktiviteter > 0 &&
      aktivitetDatum >= parseDate
    ) {
      setOpenUpdateRepeteraDialog(true);
      return;
    }

    return overLappedChanged.length === 0;
  };

  const checkDubbelbokningarDefaultEditMenuSaveAndCloseButton = (
    formContext: any
  ) => {
    const date = new Date();
    const parseDate = dateToStr(date);
    const aktivitetDatum = formContext?.formState?.currentValues?.FRANDATUM;
    const overLapped = overlappedBookings(
      currentDayBookings,
      currentDayXbridgeBookings,
      formContext.formState?.currentValues
    );
    const overLappedChanged = overLapped.filter(
      bok =>
        formContext?.formState?.values?._Associations?.AktBokRubrik_Add_Values?.find(
          (added: any) => added.id === bok.rubrikId
        ) ||
        formContext?.formState?.values?._Associations?.AktBokRubrik_Update_Values?.find(
          (updated: any) => updated.id === bok.rubrikId
        )
    );
    const antalRepeteradeAktiviteter =
      formContext.formState?.currentValues?.AntalRepeteradeAktiviteter;

    if (
      overLappedChanged.length > 0 &&
      antalRepeteradeAktiviteter &&
      antalRepeteradeAktiviteter > 0
    ) {
      setResourceDoubleBookedSingleAktivityView('saveAndClose');
      setIsOverlappedAndReapeated(true);
    }
    if (overLappedChanged.length > 0) {
      setResourceDoubleBookedSingleAktivityView('saveAndClose');
    }
    if (
      overLappedChanged.length <= 0 &&
      antalRepeteradeAktiviteter &&
      antalRepeteradeAktiviteter > 0 &&
      aktivitetDatum >= parseDate
    ) {
      setSaveAndCloseUpdate(true);
      setOpenUpdateRepeteraDialog(true);
      return;
    }
    return overLappedChanged.length === 0;
  };

  const validateDoubleBookings: IValidateFn<IAktivitetNode> = ({
    currentValues,
    customValues,
  }): IFieldValidations => {
    const validations: IFieldValidations = [];
    const currentDayXbridgeBookings =
      ((customValues as Record<string, unknown>)?.[
        'currentDayXbridgeBookings'
      ] as ICurrentDayBooking[]) ?? [];

    // Use this function with approved bookings
    const overLapped = overlappedBookings(
      currentDayBookings,
      currentDayXbridgeBookings,
      currentValues
    );

    let resultPlats: string[] = [];
    let resultPerson: string[] = [];
    let resultOvrigt: string[] = [];

    overLapped?.forEach(overlappedBooking => {
      if (overlappedBooking.bastyp === 'Plats') {
        resultPlats.push(overlappedBooking.resourceName);
      } else if (overlappedBooking.bastyp === 'Person') {
        resultPerson.push(overlappedBooking.resourceName);
      } else {
        resultOvrigt.push(overlappedBooking.resourceName);
      }
    });

    if (resultPlats.length > 0) {
      validations.push({
        fieldName: '_PLATSER',
        message: `${uniq(resultPlats).join(', ')}`,
        type: 'Warning',
      });
    }
    if (resultPerson.length > 0) {
      validations.push({
        fieldName: '_PERSONER',
        message: `${uniq(resultPerson).join(', ')}`,
        type: 'Warning',
      });
    }
    if (resultOvrigt.length > 0) {
      validations.push({
        fieldName: '_OVRIGA',
        message: `${uniq(resultOvrigt).join(', ')}`,
        type: 'Warning',
      });
    }

    return validations;
  };

  const onActivityCopied = useCallback(
    (newActivityId: string) => {
      setShowCopyActivity(false);
      if (selectOther) {
        selectOther(newActivityId);
      }
    },
    [selectOther]
  );

  const aktivitetValidateFns: IValidateFn[] = [
    validateAktivitet as IValidateFn,
    validateGudstjanstTyp(sysOptionKravVerksamhetstyp) as IValidateFn,
    validateMinimumResources as IValidateFn,
    validateDoubleBookings as IValidateFn,
  ];

  const selectDetailFromEditMenu: IEditMenuActionParams['selectDetail'] =
    selectOther == null
      ? undefined
      : (id, force) => {
          selectOther(typeof id === 'object' && id ? id.id : id, force);
        };

  return (
    <BusinessDataForm<IAktivitetNode>
      isNew={props.isNew}
      newFormContext
      data={nodeData}
      model={aktivitetModel}
      updateMutation={updateFunction}
      addMutation={addFunction}
      fullScreen={props.config?.fullPage ?? false}
      formStateActionTransformer={
        formStateActionTransformer as ActionTransformer
      }
      refetchData={nodeRefetch}
      dataLoading={nodeLoading}
      mutationError={error || addStatus.error}
      mutationLoading={loading || addStatus.loading}
      initialValue={initialValue}
      validateFns={aktivitetValidateFns}
      editMenuActions={
        !visningsTypContext.showDetailsRight
          ? [
              copyAktivityButton,
              repeteraAktivitetButton,
              defaultEditMenuCancelButton,
              {
                ...defaultEditMenuSaveButton,
                flat: true,
                hideIconIfNotFloating: true,
                onClick: editMenuActionParams => {
                  if (
                    checkDubbelbokningarDefaultEditMenuSaveButton(
                      editMenuActionParams.businessDataFormContext
                    )
                  )
                    defaultEditMenuSaveButton.onClick(editMenuActionParams);
                },
              },
              isExtraSmallScreen
                ? {
                    ...defaultEditMenuSaveAndCloseButton,
                    onClick: editMenuActionParams => {
                      if (
                        checkDubbelbokningarDefaultEditMenuSaveAndCloseButton(
                          editMenuActionParams.businessDataFormContext
                        )
                      )
                        defaultEditMenuSaveAndCloseButton.onClick(
                          editMenuActionParams
                        );
                    },
                    label: 'Spara/Stäng',
                  }
                : {
                    ...defaultEditMenuSaveAndCloseButton,
                    onClick: editMenuActionParams => {
                      if (
                        checkDubbelbokningarDefaultEditMenuSaveAndCloseButton(
                          editMenuActionParams.businessDataFormContext
                        )
                      )
                        defaultEditMenuSaveAndCloseButton.onClick(
                          editMenuActionParams
                        );
                    },
                  },
            ]
          : undefined
      }
    >
      <BusinessDataFormContext.Consumer>
        {formContext => {
          const aktivitetTyp: TEDBOAktivitetTypEnum | undefined =
            formContext?.formState?.currentValues?._typ ?? nodeData?._typ;

          const isSaving =
            loading || addStatus.loading || formContext?.mutationLoading;

          // Hanterar rensning av noteringar
          const confirmClear = () => {
            if (fieldToClear && formContext) {
              formContext.update([
                {
                  operation: 'OwnFields',
                  values: {
                    [fieldToClear]: '',
                  },
                },
              ]);
              setOpenClearNoteDialog(false);
              setFieldToClear(null);
            }
          };

          if (
            !formContext?.formState.loading &&
            !formContext?.isNew &&
            nodeData?._typ == null
          ) {
            return <div>Okänd typ</div>;
          }

          return (
            <>
              <XBridgeDubbelbokCheck
                activeDatabase={activeDatabase}
                routineID={routineID}
                formContext={formContext}
              >
                <ObjektVy
                  nodeLoading={nodeLoading}
                  editButtonDisabled={
                    (nodeData?._typ !== TEDBOAktivitetTypEnum.AKTOVRIGT &&
                      nodeData?._typ !== TEDBOAktivitetTypEnum.GUDSTJANST &&
                      !formContext?.isNew) ||
                    !(
                      me_data?.me?.[0]?.userCanEditBooking ||
                      nodeData?.BOKNINGSSIGNATUR === me_data?.me?.[0]?.sign
                    ) ||
                    (nodeData?._typ == TEDBOAktivitetTypEnum.AKTOVRIGT &&
                      isReadOnlyRutin('rtnWebKalender', availableRoutines)) ||
                    (nodeData?._typ == TEDBOAktivitetTypEnum.GUDSTJANST &&
                      isReadOnlyRutin(
                        'rtnWebBokaGudstjanst',
                        availableRoutines
                      ))
                  }
                  editButtonDisabledReason={
                    nodeData?._typ == TEDBOAktivitetTypEnum.AKTOVRIGT &&
                    isReadOnlyRutin('rtnWebKalender', availableRoutines)
                      ? `ingen behörighet att redigera aktiviteten`
                      : nodeData?._typ == TEDBOAktivitetTypEnum.GUDSTJANST &&
                        isReadOnlyRutin(
                          'rtnWebBokaGudstjanst',
                          availableRoutines
                        )
                      ? `ingen behörighet att redigera aktiviteten`
                      : !(
                          me_data?.me?.[0]?.userCanEditBooking ||
                          nodeData?.BOKNINGSSIGNATUR === me_data?.me?.[0]?.sign
                        )
                      ? `Saknar behörighet att redigera andras bokningar`
                      : `Möjlighet att redigera ${nodeData?._typ.toLowerCase()} kommer senare`
                  }
                  funktionsMenyItems={addCustomActivityFunctionMenuItem(
                    defaultFunctionMenu,
                    Boolean(formContext?.formState?.currentValues?.PRELBOKAD),
                    setOpenPremity,
                    setOpenDeleteRepeteradeAktivitetDialog,
                    !userCanEditOvrigAktGudsAktOchNoteringBooking,
                    !userCanEditOvrigAktGudsAktOchNoteringBooking
                      ? 'Saknar behörighet att redigera aktiviteten.'
                      : undefined,
                    formContext
                  )}
                >
                  <EDBox
                    sx={{
                      position: 'relative',
                      width: '100%',
                    }}
                  >
                    {(isSaving || nodeLoading) && <EDAvenyProgress overlay />}
                    <ObjektVySida
                      sidNr={1}
                      caption={
                        attributeValueDisplayText(
                          aktivitetModel,
                          '_typ',
                          avenyCollectionMap,
                          nodeData?._typ
                        ) || 'Aktivitet'
                      }
                      collectionName={aktivitetModel.CollectionName}
                    >
                      <ObjektVyKolumner>
                        <ObjektVyKolumn
                          fullPage={props.config?.fullPage ?? false}
                        >
                          <ObjektVyKort
                            className="position-relative"
                            backgroundColor={
                              prelAktivitetBackground ? 'white' : aktivitetColor
                            }
                            border={`3px solid ${
                              aktivitetColor ? aktivitetColor : 'grey'
                            }`}
                            noBoxShadow={!!nodeData?.PRELBOKAD}
                          >
                            <StyledEngineProvider injectFirst>
                              <ThemeProvider
                                theme={
                                  themeColor(nodeData?._typ)
                                    ? AvenyThemeDark
                                    : AvenyTheme
                                }
                              >
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                >
                                  <EDTypography
                                    variant="subtitle2"
                                    color="black"
                                    width={'100%'}
                                    data-testid="aktivitet_bokningsnummer"
                                  >
                                    Bokningsnummer: {nodeData?.BOKNINGSNUMMER}
                                  </EDTypography>
                                  {nodeData?.PRELBOKAD && (
                                    <EDTypography
                                      color={aktivitetColor}
                                      fontSize={isSmall ? '15px' : '16px'}
                                      marginRight="10px"
                                    >
                                      Preliminär
                                    </EDTypography>
                                  )}
                                  {formContext?.formState?.currentValues &&
                                    hasActivityIcons(
                                      formContext?.formState?.currentValues
                                    ) && (
                                      <div style={{ marginLeft: 'auto' }}>
                                        <ActivityIcons
                                          activity={
                                            formContext?.formState
                                              ?.currentValues
                                          }
                                          size="medium"
                                          showTooltips={true}
                                        />
                                      </div>
                                    )}
                                </div>

                                <EDTypography variant="h5" color="black">
                                  {nodeData?.Titel2 || nodeData?.TITEL}
                                </EDTypography>
                                <EDTypography
                                  data-testid="bokningsDatum"
                                  variant="subtitle2"
                                  color="black"
                                >
                                  {formContext?.mutationLoading ||
                                  formContext?.formState.loading ||
                                  formContext?.isNew ||
                                  nodeLoading
                                    ? ''
                                    : FormattedDayTime}
                                </EDTypography>
                                <EDTypography
                                  testId="BokadAv"
                                  variant="subtitle2"
                                  color="black"
                                >
                                  Bokad av: {nodeData?.BokadAv}
                                </EDTypography>
                              </ThemeProvider>
                            </StyledEngineProvider>
                          </ObjektVyKort>

                          {userCanEditOvrigAktGudsAktOchNoteringBooking ||
                          nodeData?._typ === 'BEGRAVNING' ? (
                            <AttributGrupp
                              readOnly={
                                !userCanEditOvrigAktGudsAktOchNoteringBooking
                              }
                            >
                              <GridContext.Provider value={{ inGrid: true }}>
                                <ObjektVyKortDel>
                                  <Attribut<IAktivitetNode>
                                    name="TITEL"
                                    mode="edit"
                                    autoFocus={
                                      !formContext?.formState?.currentValues
                                        ?.TITEL
                                    }
                                  />
                                  {!(
                                    aktivitetTyp ===
                                    TEDBOAktivitetTypEnum.GUDSTJANST
                                  ) &&
                                  aktivitetTyp ===
                                    TEDBOAktivitetTypEnum.AKTOVRIGT ? (
                                    <VerksamhetstypSelect
                                      sysOptionKravVerksamhetstyp={
                                        sysOptionKravVerksamhetstyp
                                      }
                                    />
                                  ) : aktivitetTyp ===
                                    TEDBOAktivitetTypEnum.GUDSTJANST ? (
                                    <ObjektLank<IAktivitetAssociations>
                                      associationName="GudstjanstTyp"
                                      required={true}
                                      // ↓↓ data dependency to know what gudstjänsttyp  values should the function compare to
                                      validValues={{
                                        skipSort: true,
                                        //↓↓ added FORK to fix the issue with the order of the Gudstjanst types ↓↓
                                        dataDependencies: [
                                          'NYTT_NAMN',
                                          'PRIO_ORDNING',
                                        ],
                                        validValuesFunction: suggestions =>
                                          mergeSort(
                                            suggestions,
                                            (suggestion1, suggestion2) => {
                                              const primaryCompare =
                                                Number(
                                                  suggestion1.data
                                                    .PRIO_ORDNING ?? 1000
                                                ) -
                                                Number(
                                                  suggestion2.data
                                                    .PRIO_ORDNING ?? 1000
                                                );
                                              if (primaryCompare !== 0)
                                                return primaryCompare;
                                              return stringCompare(
                                                suggestion1.data.NYTT_NAMN ??
                                                  '',
                                                suggestion2.data.NYTT_NAMN ?? ''
                                              );
                                            }
                                          ),
                                      }}
                                      onAssociationSelected={suggestion => {
                                        formContext?.update([
                                          {
                                            operation: 'Ref',
                                            associationName: 'GudstjanstTyp',
                                            id: suggestion
                                              ? suggestion.value
                                              : null,
                                            values: suggestion
                                              ? {
                                                  // ↓↓ to send the name of the gudstjanstyp so it can be used as a title
                                                  NYTT_NAMN:
                                                    suggestion.data.NYTT_NAMN,
                                                }
                                              : null,
                                          },
                                        ]);
                                      }}
                                      value={
                                        formContext?.formState.currentValues
                                          ?._Associations?.GudstjanstTyp?.id
                                      }
                                    />
                                  ) : null}

                                  {!(
                                    aktivitetTyp ===
                                    TEDBOAktivitetTypEnum.GUDSTJANST
                                  ) &&
                                  aktivitetTyp ===
                                    TEDBOAktivitetTypEnum.AKTOVRIGT &&
                                  formContext?.formState.currentValues
                                    ?._Associations?.Verksamhetstyp
                                    ?.AnvandsPaGrupp &&
                                  formContext?.formState.currentValues
                                    ?._Associations?.Verksamhetstyp?.id ? (
                                    <ObjektLank<IAktivitetAssociations>
                                      associationName="OpGrupp"
                                      validValues={{
                                        urval: getGruppUrval(
                                          formContext?.formState.currentValues
                                            ?._Associations?.Verksamhetstyp?.id,
                                          formContext?.formState.currentValues
                                            ?.FRANDATUM,
                                          formContext?.formState.currentValues
                                            ?.TILLDATUM
                                        ),
                                      }}
                                      testId="grupp_av_personer"
                                    />
                                  ) : null}
                                </ObjektVyKortDel>
                                <ObjektVyKortDel mobileFlex>
                                  <Attribut<IAktivitetNode>
                                    name="FRANDATUM"
                                    mode="edit"
                                  />
                                  <Attribut<IAktivitetNode>
                                    name="FRANTID"
                                    mode="edit"
                                  />
                                </ObjektVyKortDel>
                                <ObjektVyKortDel mobileFlex>
                                  <Attribut<IAktivitetNode>
                                    name="TILLDATUM"
                                    mode="edit"
                                  />
                                  <Attribut<IAktivitetNode>
                                    name="TILLTID"
                                    mode="edit"
                                  />
                                  <Dialog
                                    title={'Välj åtgärd'}
                                    open={openPremity}
                                    onClose={() => setOpenPremity(false)}
                                    footerActions={[
                                      {
                                        label: 'Avbryt',
                                        onClick: () => {
                                          setOpenPremity(false);
                                        },
                                      },
                                      {
                                        label: 'Ja',
                                        onClick: () => {
                                          formContext?.update([
                                            {
                                              operation: 'OwnFields',
                                              values: {
                                                PRELBOKAD:
                                                  !formContext.formState
                                                    .currentValues.PRELBOKAD,
                                              },
                                            },
                                          ]);
                                          setOpenPremity(false);
                                        },
                                      },
                                    ]}
                                  >
                                    <EDTypography>
                                      {formContext?.formState?.currentValues
                                        ?.PRELBOKAD
                                        ? 'Vill du att aktiviteten ska vara icke preliminär?'
                                        : 'Vill du att aktiviteten ska vara preliminär?'}
                                    </EDTypography>
                                  </Dialog>
                                  <DeleteRepeteradeAktivitetDialog
                                    formContext={formContext}
                                    openDeleteRepeteradeAktivitetDialog={
                                      openDeleteRepeteradeAktivitetDialog
                                    }
                                    setOpenDeleteRepeteradeAktivitetDialog={
                                      setOpenDeleteRepeteradeAktivitetDialog
                                    }
                                    aktivitetId={{ id: nodeData?.id }}
                                    activeDatabase={activeDatabase || undefined}
                                  ></DeleteRepeteradeAktivitetDialog>
                                  {formContext?.formState.currentValues &&
                                    showCopyActivity && (
                                      <CopyActivityDialog
                                        open={showCopyActivity}
                                        setOpen={setShowCopyActivity}
                                        formContext={formContext}
                                        resursLista={resursLista}
                                        onActivityCopied={onActivityCopied}
                                      />
                                    )}
                                  {formContext?.formState.currentValues &&
                                    dialogOpen && (
                                      <RepeteraAktivitetDialog
                                        open={dialogOpen}
                                        setOpen={setDialogOpen}
                                        aktivitet={
                                          formContext.formState.currentValues
                                        }
                                        activeDatabase={
                                          activeDatabase || undefined
                                        }
                                      />
                                    )}

                                  {formContext?.formState.currentValues && (
                                    <DubbelbokningsvarningDialog
                                      open={
                                        resourceDoubleBookedSingleAktivityView
                                      }
                                      overlappedBookings={overlappedBookings(
                                        currentDayBookings,
                                        currentDayXbridgeBookings,
                                        formContext?.formState.currentValues
                                      )}
                                      onClose={yes => {
                                        const date = new Date();
                                        const parseDate = dateToStr(date);
                                        const aktivitetDatum =
                                          formContext?.formState?.currentValues
                                            ?.FRANDATUM;
                                        setResourceDoubleBookedSingleAktivityView(
                                          null
                                        );

                                        if (yes && !isOverlappedAndRepeated) {
                                          const currentOverlapped =
                                            overlappedBookings(
                                              currentDayBookings,
                                              currentDayXbridgeBookings,
                                              formContext?.formState
                                                .currentValues
                                            );

                                          const newApprovedBookings = [
                                            ...approvedDoubleBookings,
                                            ...currentOverlapped.map(
                                              booking => {
                                                // Find the matching AktBokRubrik with the type
                                                const matchingRubrik =
                                                  formContext?.formState.currentValues?._Associations?.AktBokRubrik?.find(
                                                    (
                                                      rub: AktivitetQuery_node_TEDBOAktivitet__Associations_AktBokRubrik
                                                    ) =>
                                                      rub._Associations?.Resurs
                                                        ?.BO_RESURS_NAMN ===
                                                      booking.resourceName
                                                  );

                                                return {
                                                  resursId:
                                                    matchingRubrik
                                                      ?._Associations?.Resurs
                                                      ?.BO_RESURS_ID ?? '',
                                                  startTime: booking.resStart,
                                                  endTime: booking.resEnd,
                                                };
                                              }
                                            ),
                                          ];

                                          setApprovedDoubleBookings(
                                            newApprovedBookings
                                          );

                                          if (
                                            resourceDoubleBookedSingleAktivityView ===
                                            'saveAndClose'
                                          ) {
                                            const editMenuActionParams: IEditMenuActionParams =
                                              {
                                                businessDataFormContext:
                                                  formContext,
                                                editMenuOnCancel: () => {},
                                                selectDetail:
                                                  selectDetailFromEditMenu,
                                              };
                                            defaultEditMenuSaveAndCloseButton.onClick(
                                              editMenuActionParams
                                            );
                                          } else {
                                            const editMenuActionParams: IEditMenuActionParams =
                                              {
                                                businessDataFormContext:
                                                  formContext,
                                                editMenuOnCancel: () => {},
                                              };
                                            defaultEditMenuSaveButton.onClick(
                                              editMenuActionParams
                                            );
                                          }
                                        }
                                        if (
                                          yes &&
                                          isOverlappedAndRepeated &&
                                          aktivitetDatum >= parseDate
                                        ) {
                                          setOpenUpdateRepeteraDialog(true);
                                        }
                                      }}
                                    />
                                  )}
                                </ObjektVyKortDel>
                                <ObjektVyKortDel>
                                  {nodeData?._typ === 'BEGRAVNING' && (
                                    <ObjektLank<IAktivitetAssociations>
                                      associationName="Begravningstyp"
                                      fullWidth
                                      disabled={!formContext?.isNew}
                                      disableAssociationLink={
                                        !userCanEditOvrigAktGudsAktOchNoteringBooking
                                      }
                                    />
                                  )}
                                </ObjektVyKortDel>
                              </GridContext.Provider>
                            </AttributGrupp>
                          ) : (
                            <></>
                          )}
                          {formContext?.formState.currentValues &&
                            openUpdateRepeteraDialog && (
                              <UpdateRepeteraAktivitet
                                formContext={formContext}
                                openUpdateRepeteraDialog={
                                  openUpdateRepeteraDialog
                                }
                                setOpenUpdateRepeteraDialog={
                                  setOpenUpdateRepeteraDialog
                                }
                                activeDatabase={activeDatabase}
                                saveAndCloseUpdate={saveAndCloseUpdate}
                                aktivitetId={{ id: nodeData?.id }}
                              />
                            )}
                          <ResursAvvikandeTid
                            formContext={formContext}
                            deviatingTimeOpen={deviatingTimeOpen}
                            setDeviatingTimeOpen={setDeviatingTimeOpen}
                          />
                          <ObjektVyKort
                            caption="Resurser"
                            button={() => (
                              <EDButton
                                disabled={
                                  resursLista.length === 0 ||
                                  !userCanEditOvrigAktGudsAktOchNoteringBooking
                                }
                                onClick={() => setDeviatingTimeOpen(true)}
                                label="AVVIKANDE TIDER"
                                flat
                                tooltip={'Hantera avvikande tider'}
                                icon={
                                  <EDIcon
                                    iconType="deviating_time"
                                    marginRight={1}
                                    color={
                                      resursLista.length < 1 ||
                                      !userCanEditOvrigAktGudsAktOchNoteringBooking
                                        ? 'disabled'
                                        : 'primary'
                                    }
                                  ></EDIcon>
                                }
                              />
                            )}
                          >
                            <ResursTypContextProvider>
                              <AktivitetResursValjare
                                userSign={me_data?.me?.[0]?.sign}
                                allAktResursRubriker={allAktResursRubriker?.filter(
                                  rub =>
                                    rub.id ===
                                    formContext?.formState?.currentValues?.id
                                )}
                                currentBokningsRubrikPosnr={formContext?.formState?.currentValues?._Associations?.AktBokRubrik?.map(
                                  (
                                    rub: AktivitetQuery_node_TEDBOAktivitet__Associations_AktBokRubrik
                                  ) => rub.AKTRESRUB_POSNR
                                ).filter((pos: number) => Boolean(pos))}
                                fullWidth
                                rightMargin
                                activeDatabase={activeDatabase || undefined}
                                formContext={formContext}
                                disableMode={
                                  !userCanEditOvrigAktGudsAktOchNoteringBooking
                                }
                                userSettings={me_data?.me?.[0]}
                                nodeData={nodeData}
                                me_data={me_data}
                                availableRoutines={availableRoutines}
                              />
                            </ResursTypContextProvider>
                          </ObjektVyKort>
                        </ObjektVyKolumn>

                        <ObjektVyKolumn
                          fullPage={props.config?.fullPage ?? false}
                        >
                          <ObjektVyKort caption="Noteringar">
                            {/* Extern notering */}
                            <Attribut<IAktivitetNode>
                              name="BESKRIVNING"
                              multiline={true}
                              minRows={2}
                              maxRows={5}
                              disabled={
                                !userCanEditOvrigAktGudsAktOchNoteringBooking
                              }
                              onBeforeClear={() =>
                                handleClearRequest('BESKRIVNING')
                              }
                            />
                            {/* Intern notering */}
                            <Attribut<IAktivitetNode>
                              name="NOTERING2"
                              multiline={true}
                              minRows={2}
                              maxRows={5}
                              disabled={
                                nodeData?._masktype
                                  ? true
                                  : me_data?.me?.[0]?.userCanEditBooking ||
                                    nodeData?.BOKNINGSSIGNATUR ===
                                      me_data?.me?.[0]?.sign ||
                                    !isReadOnlyRutin(
                                      'rtnWebKalender',
                                      availableRoutines
                                    )
                                  ? false
                                  : true
                              }
                              onBeforeClear={() =>
                                handleClearRequest('NOTERING2')
                              }
                            />
                            <Dialog
                              title={'Rensa notering'}
                              open={openClearNoteDialog}
                              onClose={() => {
                                setOpenClearNoteDialog(false);
                                setFieldToClear(null);
                              }}
                              footerActions={[
                                {
                                  label: 'Avbryt',
                                  onClick: () => {
                                    setOpenClearNoteDialog(false);
                                    setFieldToClear(null);
                                  },
                                },
                                {
                                  label: 'Ta bort',
                                  onClick: confirmClear,
                                },
                              ]}
                            >
                              <EDTypography>
                                {`Denna åtgärd tar bort den ${
                                  fieldToClear === 'BESKRIVNING'
                                    ? 'externa'
                                    : 'interna'
                                } noteringen för alla användare. Vill du fortsätta?`}
                              </EDTypography>
                            </Dialog>
                          </ObjektVyKort>
                          <BusinessDataForm
                            model={aktivitetModel}
                            localValuesInChildForm
                          >
                            <BevakningDialog
                              open={openBevakning}
                              setOpenBevakning={setOpenBevakning}
                              formContext={formContext}
                              meData={me_data?.me}
                            />
                          </BusinessDataForm>
                          <ObjektVyKort
                            caption="Bevakning"
                            button={() => (
                              <EDButton
                                disabled={
                                  !userCanEditOvrigAktGudsAktOchNoteringBooking
                                }
                                onClick={() => setOpenBevakning(true)}
                                label="HANTERA BEVAKNING"
                                flat
                                tooltip={'Hantera bevakningar'}
                                icon={
                                  <EDIcon
                                    iconType="visibility"
                                    marginRight={0.5}
                                    color={
                                      !userCanEditOvrigAktGudsAktOchNoteringBooking
                                        ? 'disabled'
                                        : 'primary'
                                    }
                                    testId="visibility"
                                  />
                                }
                                testId="bevakningButton"
                              />
                            )}
                          >
                            {formContext?.formState?.currentValues?.BEVAKNING &&
                            (formContext?.formState?.currentValues
                              ?.BEVAKNING_DATUM ||
                              formContext?.formState?.currentValues
                                ?.BEVAKNING_TEXT) ? (
                              <>
                                <EDCaptionedValue
                                  label="Bevakningsdatum"
                                  name={
                                    attrInfoStatistikStatus.attribute
                                      .AttributeName
                                  }
                                  size="large"
                                >
                                  <AttributeDisplayText
                                    value={
                                      formContext?.formState?.currentValues
                                        ?.BEVAKNING_DATUM &&
                                      formContext?.formState?.currentValues
                                        ?.BEVAKNING_DATUM
                                    }
                                    attributeModel={
                                      attrInfoStatistikStatus.attribute
                                    }
                                    collection={aktivitetModel}
                                    forceText
                                  />
                                </EDCaptionedValue>
                                <EDCaptionedValue
                                  label="Text"
                                  name={
                                    attrInfoStatistikStatus.attribute
                                      .AttributeName
                                  }
                                  size="large"
                                >
                                  <AttributeDisplayText
                                    value={
                                      formContext?.formState?.currentValues
                                        ?.BEVAKNING_TEXT
                                    }
                                    attributeModel={
                                      attrInfoStatistikStatus.attribute
                                    }
                                    collection={aktivitetModel}
                                    forceText
                                  />
                                </EDCaptionedValue>
                              </>
                            ) : formContext?.formState?.currentValues
                                ?.BEVAKNING &&
                              !formContext?.formState?.currentValues
                                ?.BEVAKNING_DATUM &&
                              !formContext?.formState?.currentValues
                                .BEVAKNING_TEXT ? (
                              <AttributeDisplayText
                                value={`Bevakas av: ${loginStateContext.name}`}
                                attributeModel={
                                  attrInfoStatistikStatus.attribute
                                }
                                collection={aktivitetModel}
                                forceText
                              />
                            ) : (
                              <AttributeDisplayText
                                value={'Aktiviteten är inte bevakad'}
                                attributeModel={
                                  attrInfoStatistikStatus.attribute
                                }
                                collection={aktivitetModel}
                                forceText
                                testId="activityNoBevakning"
                              />
                            )}
                          </ObjektVyKort>

                          <ObjektVyKort
                            caption="Dokument"
                            readOnly={
                              !userCanEditOvrigAktGudsAktOchNoteringBooking
                            }
                          >
                            <AssociationList
                              collectionName={aktivitetModel.CollectionName}
                              associationName={'Dokument'}
                              associationPath={'Dokument'}
                              ownId={nodeData?.id ?? null}
                              config={dokConfig}
                            />
                          </ObjektVyKort>

                          <ObjektVyKort
                            caption="Statistik"
                            readOnly={
                              !userCanEditOvrigAktGudsAktOchNoteringBooking
                            }
                          >
                            <EDColumns spacing={2} maxWidth={600}>
                              <EDColumn>
                                <ObjektLank<IAktivitetAssociations>
                                  associationName="Forsamling"
                                  fullWidth
                                />
                                {nodeData?.id && (
                                  <>
                                    <EDCaptionedValue
                                      label="Status"
                                      name={
                                        attrInfoStatistikStatus.attribute
                                          .AttributeName
                                      }
                                      size="large"
                                    >
                                      <AttributeDisplayText
                                        value={
                                          nodeData?.STATISTIKUPPGIFT
                                            ? nodeData?.StatistikStatus
                                            : 'Rapporteras ej'
                                        }
                                        attributeModel={
                                          attrInfoStatistikStatus.attribute
                                        }
                                        collection={aktivitetModel}
                                        forceText
                                      />
                                    </EDCaptionedValue>
                                    <Attribut<IAktivitetNode>
                                      name="StatistikSenastUppdaterad"
                                      customDisplayLabel="Exporterad"
                                      size="large"
                                      disableEditMode={true}
                                    />
                                  </>
                                )}
                              </EDColumn>
                              {nodeData?.id && (
                                <EDColumn>
                                  <EDBox
                                    sx={
                                      formContext?.formState.editMode
                                        ? {
                                            paddingTop: 1.5,
                                          }
                                        : undefined
                                    }
                                  >
                                    <StatistikrapporteringCard
                                      id={nodeData?.id}
                                    />
                                  </EDBox>
                                </EDColumn>
                              )}
                            </EDColumns>
                          </ObjektVyKort>
                        </ObjektVyKolumn>
                      </ObjektVyKolumner>
                    </ObjektVySida>
                  </EDBox>
                  <ObjektVySida
                    sidNr={2}
                    caption="Info"
                    collectionName={aktivitetModel.CollectionName}
                    hidden={
                      (!(me_data?.me?.[0]?.userCanViewBookingInfo ?? false) &&
                        //Kolla om användare finns i sparad bokningsdata (ej i form state)
                        !nodeData?._Associations?.AktBokRubrik?.some(
                          (
                            rub: AktivitetQuery_node_TEDBOAktivitet__Associations_AktBokRubrik
                          ) =>
                            rub._Associations?.Resurs?.BO_RESURS_ID ===
                            me_data?.me?.[0]?.userBookingID
                        )) ||
                      (nodeData?._typ !== 'BEGRAVNING' &&
                        nodeData?._typ !== 'VIGSEL' &&
                        nodeData?._typ !== 'DOP' &&
                        nodeData?._typ !== 'GRAVSATTNING' &&
                        nodeData?._typ !== 'KONFIRMATION' &&
                        nodeData?._typ !== 'LOKALUTHYRNING')
                    }
                  >
                    <ObjektVyKolumner>
                      <ObjektVyKolumn
                        fullPage={props.config?.fullPage ?? false}
                      >
                        <ObjektVyKort
                          className="position-relative"
                          backgroundColor={
                            prelAktivitetBackground ? 'white' : aktivitetColor
                          }
                          masonryItemPaddingBottom={'normal'}
                          border={`3px solid ${
                            aktivitetColor ? aktivitetColor : 'grey'
                          }`}
                          noBoxShadow={!!nodeData?.PRELBOKAD}
                        >
                          <StyledEngineProvider injectFirst>
                            <ThemeProvider
                              theme={
                                themeColor(nodeData?._typ)
                                  ? AvenyThemeDark
                                  : AvenyTheme
                              }
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                <EDTypography
                                  variant="subtitle2"
                                  color="black"
                                  width={'100%'}
                                >
                                  Bokningsnummer: {nodeData?.BOKNINGSNUMMER}
                                </EDTypography>
                                {nodeData?.PRELBOKAD && (
                                  <EDTypography
                                    color={aktivitetColor}
                                    fontSize={isSmall ? '15px' : '16px'}
                                  >
                                    Preliminär
                                  </EDTypography>
                                )}
                                {formContext?.formState?.currentValues &&
                                  hasActivityIcons(
                                    formContext?.formState?.currentValues
                                  ) && (
                                    <div style={{ marginLeft: 'auto' }}>
                                      <ActivityIcons
                                        activity={
                                          formContext?.formState?.currentValues
                                        }
                                        size="medium"
                                        showTooltips={true}
                                      />
                                    </div>
                                  )}
                              </div>
                              <EDTypography variant="h5" color="black">
                                {nodeData?.Titel2 || nodeData?.TITEL}
                              </EDTypography>
                              <EDTypography
                                data-testid="bokningsDatum"
                                variant="subtitle2"
                                color="black"
                              >
                                {formContext?.mutationLoading ||
                                formContext?.formState.loading ||
                                formContext?.isNew ||
                                nodeLoading
                                  ? ''
                                  : FormattedDayTime}
                              </EDTypography>
                              <EDTypography
                                testId="BokadAv"
                                variant="subtitle2"
                                color="black"
                              >
                                Bokad av: {nodeData?.BokadAv}
                              </EDTypography>
                            </ThemeProvider>
                          </StyledEngineProvider>
                        </ObjektVyKort>
                        <ObjektVyKort>
                          <AvlidenInfo
                            data={nodeData}
                            aktivitetModel={aktivitetModel}
                            avenyCollectionMap={avenyCollectionMap}
                          />
                        </ObjektVyKort>
                      </ObjektVyKolumn>
                      <ObjektVyKolumn
                        fullPage={props.config?.fullPage ?? false}
                      >
                        <ObjektVyKort
                          masonryItemPaddingBottom="normal"
                          caption="Noteringar"
                        >
                          <Attribut<IAktivitetNode>
                            name="BESKRIVNING"
                            multiline={true}
                            minRows={2}
                            maxRows={5}
                            disabled={
                              !userCanEditOvrigAktGudsAktOchNoteringBooking
                            }
                          />
                          <Attribut<IAktivitetNode>
                            name="NOTERING2"
                            multiline={true}
                            minRows={2}
                            maxRows={5}
                            disabled={
                              me_data?.me?.[0]?.userCanEditBooking ||
                              nodeData?.BOKNINGSSIGNATUR ===
                                me_data?.me?.[0]?.sign ||
                              !isReadOnlyRutin(
                                'rtnWebKalender',
                                availableRoutines
                              )
                                ? false
                                : true
                            }
                          />
                        </ObjektVyKort>
                      </ObjektVyKolumn>
                    </ObjektVyKolumner>
                  </ObjektVySida>

                  <ObjektVySida
                    sidNr={3}
                    caption="Publicera aktivitet"
                    hidden={
                      !publicering ||
                      nodeData?._typ === 'BEGRAVNING' ||
                      nodeData?._typ === 'VIGSEL' ||
                      nodeData?._typ === 'DOP' ||
                      nodeData?._typ === 'GRAVSATTNING'
                    }
                    collectionName={aktivitetModel.CollectionName}
                  >
                    <EDBox
                      sx={{
                        overflow: 'auto',
                        height: isSmall ? undefined : '100%',
                      }}
                    >
                      {formContext?.formState.currentValues &&
                        openUpdateRepeteraDialog && (
                          <UpdateRepeteraAktivitet
                            formContext={formContext}
                            openUpdateRepeteraDialog={openUpdateRepeteraDialog}
                            setOpenUpdateRepeteraDialog={
                              setOpenUpdateRepeteraDialog
                            }
                            activeDatabase={activeDatabase}
                            saveAndCloseUpdate={saveAndCloseUpdate}
                            aktivitetId={props.id}
                          />
                        )}
                      <ObjektVyKolumner fullHeight={!isSmall}>
                        <ObjektVyKolumn
                          fullPage={props.config?.fullPage ?? false}
                          fullHeight={!isSmall}
                          flex={!isSmall}
                        >
                          <ObjektVyKort
                            backgroundColor={
                              prelAktivitetBackground ? 'white' : aktivitetColor
                            }
                            border={`3px solid ${
                              aktivitetColor ? aktivitetColor : 'grey'
                            }`}
                            noBoxShadow={!!nodeData?.PRELBOKAD}
                          >
                            <StyledEngineProvider injectFirst>
                              <ThemeProvider
                                theme={
                                  themeColor(nodeData?._typ)
                                    ? AvenyThemeDark
                                    : AvenyTheme
                                }
                              >
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                >
                                  <EDTypography
                                    variant="subtitle2"
                                    color="black"
                                    width={'100%'}
                                  >
                                    Bokningsnummer: {nodeData?.BOKNINGSNUMMER}
                                  </EDTypography>
                                  {nodeData?.PRELBOKAD && (
                                    <EDTypography
                                      color={aktivitetColor}
                                      fontSize={isSmall ? '15px' : '16px'}
                                    >
                                      Preliminär
                                    </EDTypography>
                                  )}
                                  {formContext?.formState?.currentValues &&
                                    hasActivityIcons(
                                      formContext?.formState?.currentValues
                                    ) && (
                                      <div style={{ marginLeft: 'auto' }}>
                                        <ActivityIcons
                                          activity={
                                            formContext?.formState
                                              ?.currentValues
                                          }
                                          size="medium"
                                          showTooltips={true}
                                        />
                                      </div>
                                    )}
                                </div>
                                <EDTypography variant="h5" color="black">
                                  {nodeData?.Titel2}
                                </EDTypography>
                                {!formContext?.mutationLoading &&
                                !formContext?.formState.loading &&
                                !formContext?.isNew ? (
                                  <EDTypography
                                    variant="subtitle2"
                                    color="black"
                                  >
                                    {FormattedDayTime}
                                  </EDTypography>
                                ) : (
                                  ''
                                )}
                                <EDTypography
                                  testId="BokadAv"
                                  variant="subtitle2"
                                  color="black"
                                >
                                  Bokad av: {nodeData?.BokadAv}
                                </EDTypography>
                              </ThemeProvider>
                            </StyledEngineProvider>
                          </ObjektVyKort>

                          <ObjektVyKort>
                            <EDCheckbox
                              label={'Extern publicering'}
                              tooltip={'Publiceras i Nationella Kalendern'}
                              checked={Boolean(
                                formContext?.formState.currentValues
                                  ?.SKK_SPRIDNINGSTYP_EXTERN
                              )}
                              disabled={
                                !formContext?.formState.editMode ||
                                !userCanEditOvrigAktGudsAktOchNoteringBooking
                              }
                              {...getFieldValidationInfo(
                                formContext?.formState?.validation,
                                'SKK_SPRIDNINGSTYP_EXTERN'
                              )}
                              onCheck={checked => {
                                formContext?.update([
                                  {
                                    operation: 'OwnFields',
                                    values: {
                                      SKK_SPRIDNINGSTYP_EXTERN: checked,
                                    },
                                  },
                                ]);
                              }}
                            />
                            <EDCheckbox
                              label={'Intern publicering'}
                              tooltip={
                                'Publiceras på interna informationsskärmar'
                              }
                              checked={Boolean(
                                formContext?.formState.currentValues
                                  ?.SKK_PUBL_STATUS_INTERN
                              )}
                              disabled={
                                !formContext?.formState.editMode ||
                                !userCanEditOvrigAktGudsAktOchNoteringBooking
                              }
                              onCheck={checked => {
                                formContext?.update([
                                  {
                                    operation: 'OwnFields',
                                    values: {
                                      SKK_PUBL_STATUS_INTERN: checked,
                                    },
                                  },
                                ]);
                              }}
                            />
                            <EDTypography paddingLeft={'32px'} variant="body1">
                              Senast exporterad:{' '}
                              {formContext?.formState?.currentValues
                                ?._Associations?.SKK?.SENAST_SKICKAD
                                ? formContext?.formState?.currentValues?._Associations?.SKK?.SENAST_SKICKAD.replace(
                                    /(\d{4}-\d{2}-\d{2}) (\d{2}:\d{2}):\d{2}/,
                                    '$1, $2'
                                  )
                                : '-'}
                            </EDTypography>
                          </ObjektVyKort>
                          <EDBox
                            sx={{
                              display: 'flex',
                              flexDirection: isExtraSmall ? 'column' : 'row',
                              overflow: 'hidden',
                              overflowY: 'hidden',
                              gap: theme => theme.spacing(1),
                              minHeight: '200px',
                            }}
                          >
                            <ObjektVyKort
                              caption="Händelsetyper"
                              cardFullHeight
                              overflowAuto
                              cardFlex
                              masonryItemPaddingBottom="dense"
                            >
                              <EDBox
                                sx={{
                                  overflow: 'auto',
                                  height: isSmall ? '300px' : '100%',
                                }}
                              >
                                {handelsetyp_data?.db?.BOSKKHandelsetyp_All?.map(
                                  handTyp => (
                                    <EDBox
                                      sx={{ paddingLeft: 2 }}
                                      key={handTyp.id}
                                    >
                                      <EDCheckbox
                                        key={handTyp.id}
                                        label={handTyp.BENAMNING}
                                        disabled={
                                          !formContext?.formState.editMode ||
                                          !userCanEditOvrigAktGudsAktOchNoteringBooking
                                        }
                                        checked={Boolean(
                                          formContext?.formState.currentValues?._Associations?.Handelsetyper_All?.find(
                                            (
                                              aktHandTyp: AktivitetQuery_node_TEDBOAktivitet__Associations_Handelsetyper_All
                                            ) =>
                                              aktHandTyp._Associations
                                                ?.Handelsetyp?.id === handTyp.id
                                          )
                                        )}
                                        onCheck={checked => {
                                          const handelsetyper =
                                            formContext?.formState.currentValues?._Associations?.Handelsetyper_All?.find(
                                              (
                                                aktHandTyp: AktivitetQuery_node_TEDBOAktivitet__Associations_Handelsetyper_All
                                              ) =>
                                                aktHandTyp._Associations
                                                  ?.Handelsetyp?.id ===
                                                handTyp.id
                                            );

                                          const handelsetyperUpdate: FormUpdateAssociatonType =
                                            checked
                                              ? {
                                                  operation: 'Add_Values',
                                                  associationName:
                                                    'Handelsetyper',
                                                  id: `${NEWLY_ADDED_ID_PREFIX_FOR_UPDATE}${handTyp.BENAMNING}`,
                                                  values: {
                                                    _Associations: {
                                                      Handelsetyp_Ref: {
                                                        id: handTyp.id,
                                                      },
                                                      Aktivitet_Ref: {
                                                        id: formContext
                                                          ?.formState
                                                          .currentValues?.id,
                                                      },
                                                    },
                                                  },
                                                }
                                              : {
                                                  operation: 'Delete_Values',
                                                  associationName:
                                                    'Handelsetyper',
                                                  id: handelsetyper?.id ?? '',
                                                };
                                          formContext?.update([
                                            handelsetyperUpdate,
                                          ]);
                                        }}
                                      ></EDCheckbox>
                                    </EDBox>
                                  )
                                )}
                              </EDBox>
                            </ObjektVyKort>

                            <ObjektVyKort
                              caption="Gemensamma Ämnesområden"
                              cardFullHeight
                              overflowAuto
                              cardFlex
                              masonryItemPaddingBottom="dense"
                            >
                              <EDBox
                                sx={{
                                  overflow: 'auto',
                                  height: isSmall ? '300px' : '100%',
                                }}
                              >
                                {mergeSort(
                                  amnesomraden?.db?.BOSKKAmnesomraden_All?.filter(
                                    amnesOmrade => amnesOmrade.ORG_ID === -1
                                  ) ?? [],
                                  (a, b) =>
                                    stringCompare(a.HEADLINE, b.HEADLINE)
                                ).map(amnesOmrade => (
                                  <EDBox
                                    sx={{ paddingLeft: 2 }}
                                    key={amnesOmrade.id}
                                  >
                                    <EDCheckbox
                                      key={amnesOmrade.id}
                                      label={amnesOmrade.HEADLINE}
                                      disabled={
                                        !formContext?.formState.editMode ||
                                        !userCanEditOvrigAktGudsAktOchNoteringBooking
                                      }
                                      checked={Boolean(
                                        formContext?.formState.currentValues?._Associations?.Amnesomraden_All?.find(
                                          (
                                            aktAmnesOmr: AktivitetQuery_node_TEDBOAktivitet__Associations_Amnesomraden_All
                                          ) =>
                                            aktAmnesOmr._Associations
                                              ?.Amnesomrade?.id ===
                                            amnesOmrade.id
                                        )
                                      )}
                                      onCheck={checked => {
                                        const amnesOmrader =
                                          formContext?.formState.currentValues?._Associations?.Amnesomraden_All?.find(
                                            (
                                              aktAmnesOmr: AktivitetQuery_node_TEDBOAktivitet__Associations_Amnesomraden_All
                                            ) =>
                                              aktAmnesOmr._Associations
                                                ?.Amnesomrade?.id ===
                                              amnesOmrade.id
                                          );

                                        const amnesOmraderUpdate: FormUpdateAssociatonType =
                                          checked
                                            ? {
                                                operation: 'Add_Values',
                                                associationName: 'Amnesomraden',
                                                id: `${NEWLY_ADDED_ID_PREFIX_FOR_UPDATE}${amnesOmrade.HEADLINE}`,
                                                values: {
                                                  _Associations: {
                                                    Amnesomrade_Ref: {
                                                      id: amnesOmrade.id,
                                                    },
                                                    Aktivitet_Ref: {
                                                      id: formContext?.formState
                                                        .currentValues?.id,
                                                    },
                                                  },
                                                },
                                              }
                                            : {
                                                operation: 'Delete_Values',
                                                associationName: 'Amnesomraden',
                                                id: amnesOmrader?.id ?? '',
                                              };
                                        formContext?.update([
                                          amnesOmraderUpdate,
                                        ]);
                                      }}
                                    ></EDCheckbox>
                                  </EDBox>
                                ))}
                              </EDBox>
                            </ObjektVyKort>
                            <ObjektVyKort
                              caption="Lokala Ämnesområden"
                              cardFullHeight
                              overflowAuto
                              cardFlex
                              masonryItemPaddingBottom="dense"
                            >
                              <EDBox
                                sx={{
                                  overflow: 'auto',
                                  height: isSmall ? '300px' : '100%',
                                }}
                              >
                                {mergeSort(
                                  amnesomraden?.db?.BOSKKAmnesomraden_All?.filter(
                                    amnesOmrade => amnesOmrade.ORG_ID !== -1
                                  ) ?? [],
                                  (a, b) =>
                                    stringCompare(a.HEADLINE, b.HEADLINE)
                                ).map(amnesOmrade => (
                                  <EDBox
                                    sx={{ paddingLeft: 2 }}
                                    key={amnesOmrade.id}
                                  >
                                    <EDCheckbox
                                      key={amnesOmrade.id}
                                      label={amnesOmrade.HEADLINE}
                                      disabled={
                                        !formContext?.formState.editMode ||
                                        !userCanEditOvrigAktGudsAktOchNoteringBooking
                                      }
                                      checked={Boolean(
                                        formContext?.formState.currentValues?._Associations?.Amnesomraden_All?.find(
                                          (
                                            aktAmnesOmr: AktivitetQuery_node_TEDBOAktivitet__Associations_Amnesomraden_All
                                          ) =>
                                            aktAmnesOmr._Associations
                                              ?.Amnesomrade?.id ===
                                            amnesOmrade.id
                                        )
                                      )}
                                      onCheck={checked => {
                                        const amnesOmrader =
                                          formContext?.formState.currentValues?._Associations?.Amnesomraden_All?.find(
                                            (
                                              aktAmnesOmr: AktivitetQuery_node_TEDBOAktivitet__Associations_Amnesomraden_All
                                            ) =>
                                              aktAmnesOmr._Associations
                                                ?.Amnesomrade?.id ===
                                              amnesOmrade.id
                                          );

                                        const amnesOmraderUpdate: FormUpdateAssociatonType =
                                          checked
                                            ? {
                                                operation: 'Add_Values',
                                                associationName: 'Amnesomraden',
                                                id: `${NEWLY_ADDED_ID_PREFIX_FOR_UPDATE}${amnesOmrade.HEADLINE}`,
                                                values: {
                                                  _Associations: {
                                                    Amnesomrade_Ref: {
                                                      id: amnesOmrade.id,
                                                    },
                                                    Aktivitet_Ref: {
                                                      id: formContext?.formState
                                                        .currentValues?.id,
                                                    },
                                                  },
                                                },
                                              }
                                            : {
                                                operation: 'Delete_Values',
                                                associationName: 'Amnesomraden',
                                                id: amnesOmrader?.id ?? '',
                                              };
                                        formContext?.update([
                                          amnesOmraderUpdate,
                                        ]);
                                      }}
                                    ></EDCheckbox>
                                  </EDBox>
                                ))}
                              </EDBox>
                            </ObjektVyKort>
                          </EDBox>
                        </ObjektVyKolumn>
                        <ObjektVyKolumn
                          fullPage={props.config?.fullPage ?? false}
                          fullHeight
                        >
                          <ObjektVyKort caption="Noteringar">
                            <Attribut<IAktivitetNode>
                              name="BESKRIVNING"
                              multiline={true}
                              minRows={2}
                              maxRows={5}
                              disabled={
                                !userCanEditOvrigAktGudsAktOchNoteringBooking
                              }
                            />
                            <Attribut<IAktivitetNode>
                              name="NOTERING2"
                              multiline={true}
                              minRows={2}
                              maxRows={5}
                              disabled={
                                me_data?.me?.[0]?.userCanEditBooking ||
                                nodeData?.BOKNINGSSIGNATUR ===
                                  me_data?.me?.[0]?.sign ||
                                !isReadOnlyRutin(
                                  'rtnWebKalender',
                                  availableRoutines
                                )
                                  ? false
                                  : true
                              }
                            />
                          </ObjektVyKort>

                          <ObjektVyKort
                            caption="Länkar"
                            readOnly={
                              !userCanEditOvrigAktGudsAktOchNoteringBooking
                            }
                          >
                            <Attribut<IAktivitetNode> name="SKK_URL1_TITEL" />
                            <Attribut<IAktivitetNode> name="SKK_URL1" />
                            {formContext?.formState.editMode ? (
                              <EDBox sx={{ paddingLeft: 1 }}>
                                <EDCheckbox
                                  label="Länk 1 är en anslutningslänk till ett digitalt möte"
                                  checked={Boolean(
                                    formContext?.formState.currentValues
                                      ?.SKK_URL1_DIGITALT_MOTE
                                  )}
                                  onCheck={checked => {
                                    formContext?.update([
                                      {
                                        operation: 'OwnFields',
                                        values: {
                                          SKK_URL1_DIGITALT_MOTE: checked,
                                        },
                                      },
                                    ]);
                                  }}
                                  disabled={
                                    !userCanEditOvrigAktGudsAktOchNoteringBooking
                                  }
                                />
                              </EDBox>
                            ) : (
                              <Attribut<IAktivitetNode> name="SKK_URL1_DIGITALT_MOTE" />
                            )}
                            <Attribut<IAktivitetNode> name="SKK_URL2_TITEL" />
                            <Attribut<IAktivitetNode> name="SKK_URL2" />
                            <Attribut<IAktivitetNode> name="SKK_URL3_TITEL" />
                            <Attribut<IAktivitetNode> name="SKK_URL3" />
                          </ObjektVyKort>

                          <ObjektVyKort
                            caption="Kontaktperson"
                            readOnly={
                              !userCanEditOvrigAktGudsAktOchNoteringBooking
                            }
                          >
                            <Attribut<IAktivitetNode> name="SKK_KONTAKT_NAMN" />
                            <Attribut<IAktivitetNode> name="SKK_KONTAKT_TELEFON" />
                            <Attribut<IAktivitetNode> name="SKK_KONTAKT_SMTP" />
                          </ObjektVyKort>
                        </ObjektVyKolumn>
                      </ObjektVyKolumner>
                    </EDBox>
                  </ObjektVySida>

                  <ObjektVySida
                    sidNr={4}
                    caption="Värmeinställningar"
                    collectionName={aktivitetModel.CollectionName}
                    hidden={!värmestyrning}
                  >
                    {formContext?.formState.currentValues &&
                      openUpdateRepeteraDialog && (
                        <UpdateRepeteraAktivitet
                          formContext={formContext}
                          openUpdateRepeteraDialog={openUpdateRepeteraDialog}
                          setOpenUpdateRepeteraDialog={
                            setOpenUpdateRepeteraDialog
                          }
                          activeDatabase={activeDatabase}
                          saveAndCloseUpdate={saveAndCloseUpdate}
                          aktivitetId={props.id}
                        />
                      )}
                    <ObjektVyKolumner>
                      <ObjektVyKolumn
                        fullPage={props.config?.fullPage ?? false}
                      >
                        <ObjektVyKort
                          backgroundColor={
                            prelAktivitetBackground ? 'white' : aktivitetColor
                          }
                          border={`3px solid ${
                            aktivitetColor ? aktivitetColor : 'grey'
                          }`}
                          noBoxShadow={!!nodeData?.PRELBOKAD}
                        >
                          <StyledEngineProvider injectFirst>
                            <ThemeProvider
                              theme={
                                themeColor(nodeData?._typ)
                                  ? AvenyThemeDark
                                  : AvenyTheme
                              }
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                <EDTypography
                                  variant="subtitle2"
                                  color="black"
                                  width={'100%'}
                                >
                                  Bokningsnummer: {nodeData?.BOKNINGSNUMMER}
                                </EDTypography>
                                {nodeData?.PRELBOKAD && (
                                  <EDTypography
                                    color={aktivitetColor}
                                    fontSize={isSmall ? '15px' : '16px'}
                                  >
                                    Preliminär
                                  </EDTypography>
                                )}
                                {formContext?.formState?.currentValues &&
                                  hasActivityIcons(
                                    formContext?.formState?.currentValues
                                  ) && (
                                    <div style={{ marginLeft: 'auto' }}>
                                      <ActivityIcons
                                        activity={
                                          formContext?.formState?.currentValues
                                        }
                                        size="medium"
                                        showTooltips={true}
                                      />
                                    </div>
                                  )}
                              </div>
                              <EDTypography variant="h5" color="black">
                                {nodeData?.Titel2}
                              </EDTypography>
                              {!formContext?.mutationLoading &&
                              !formContext?.formState.loading &&
                              !formContext?.isNew ? (
                                <EDTypography variant="subtitle2" color="black">
                                  {FormattedDayTime}
                                </EDTypography>
                              ) : (
                                ''
                              )}
                              <EDTypography
                                testId="BokadAv"
                                variant="subtitle2"
                                color="black"
                              >
                                Bokad av: {nodeData?.BokadAv}
                              </EDTypography>
                            </ThemeProvider>
                          </StyledEngineProvider>
                        </ObjektVyKort>
                        <ObjektVyKort caption="Resurser" noPadding>
                          <EDBox paddingBottom={'16px'}></EDBox>
                          {formContext?.formState?.currentValues?._Associations?.AktBokRubrik?.map(
                            (
                              aktBokrub: AktivitetQuery_node_TEDBOAktivitet__Associations_AktBokRubrik
                            ) => {
                              if (
                                aktBokrub._Associations?.Resurs?._Associations
                                  ?.ResRestyp.Bastyp === 'Plats'
                              ) {
                                if (!isSmall) {
                                  return (
                                    <EDBox
                                      paddingBottom={'10px'}
                                      key={aktBokrub.id}
                                      display={'flex'}
                                      alignItems={'center'}
                                      justifyContent={'space-between'}
                                      paddingTop={'10px'}
                                      paddingLeft={'16px'}
                                      paddingRight={'16px'}
                                      borderBottom={'0.5px solid grey'}
                                    >
                                      <EDTypography bold color={'grey'}>
                                        {aktBokrub.FRANTID}
                                        {'-'}
                                        {aktBokrub.TILLTID}{' '}
                                        <EDBox
                                          display={'inline-block'}
                                          paddingRight={'5px'}
                                        ></EDBox>
                                        {aktBokrub.RESURS_NAMN}
                                        {'    '}
                                        {'(' +
                                          aktBokrub?._Associations?.Resurs
                                            ?.BO_RESURS_ID +
                                          ')'}
                                      </EDTypography>
                                      <EDBox maxWidth={'40%'} width={'100%'}>
                                        <EDAutoCompleteEdit<IVarmeOption>
                                          hideClear
                                          fullWidth
                                          label={'Värmeinställning'}
                                          options={varmeInstallningarOptions}
                                          getOptionLabel={option =>
                                            option?.name
                                          }
                                          value={getVarmeOption(
                                            aktBokrub?.VARME_STANDARD
                                          )}
                                          onChange={option => {
                                            formContext?.update([
                                              {
                                                operation:
                                                  aktBokrub.id.startsWith(
                                                    NEWLY_ADDED_ID_PREFIX_FOR_UPDATE
                                                  )
                                                    ? 'Add_Values'
                                                    : 'Update_Values',
                                                associationName: 'AktBokRubrik',
                                                id: aktBokrub.id,
                                                values: {
                                                  VARME_STANDARD:
                                                    option?.value ?? 20,
                                                },
                                              },
                                            ]);
                                          }}
                                          testId={'VärmeInställning'}
                                          disabled={
                                            !userCanEditOvrigAktGudsAktOchNoteringBooking
                                          }
                                        ></EDAutoCompleteEdit>
                                        {getVarmeOption(
                                          aktBokrub?.VARME_STANDARD
                                        )?.name === 'Valfri temperatur' && (
                                          <EDCounter
                                            label="Temperatur"
                                            warning={varmeWarning(
                                              aktBokrub?.VARME_STANDARD
                                            )}
                                            helperText={
                                              varmeWarning(
                                                aktBokrub?.VARME_STANDARD
                                              )
                                                ? varmeHelperText(
                                                    aktBokrub?.VARME_STANDARD
                                                  )
                                                : ''
                                            }
                                            value={aktBokrub?.VARME_STANDARD}
                                            onChange={value => {
                                              formContext?.update([
                                                {
                                                  operation:
                                                    aktBokrub.id.startsWith(
                                                      NEWLY_ADDED_ID_PREFIX_FOR_UPDATE
                                                    )
                                                      ? 'Add_Values'
                                                      : 'Update_Values',
                                                  associationName:
                                                    'AktBokRubrik',
                                                  id: aktBokrub.id,
                                                  values: {
                                                    VARME_STANDARD: value,
                                                  },
                                                },
                                              ]);
                                            }}
                                          ></EDCounter>
                                        )}
                                      </EDBox>
                                    </EDBox>
                                  );
                                } else if (
                                  userCanEditOvrigAktGudsAktOchNoteringBooking
                                ) {
                                  return (
                                    <EDExpansionPanel
                                      key={aktBokrub.id}
                                      label={
                                        <EDBox
                                          marginLeft={'16px'}
                                          marginRight={'5px'}
                                          display={'flex'}
                                          alignItems={'center'}
                                          justifyContent={'space-between'}
                                          width={'100%'}
                                        >
                                          <EDTypography
                                            maxWidth={'40%'}
                                            color={'GrayText'}
                                            fontWeight={'bold'}
                                          >
                                            {aktBokrub.FRANTID}
                                            {'-'}
                                            {aktBokrub.TILLTID}{' '}
                                            <EDBox
                                              display={'inline-block'}
                                              paddingRight={'5px'}
                                            ></EDBox>
                                            {aktBokrub.RESURS_NAMN}
                                            {'    '}
                                            {'(' +
                                              aktBokrub?._Associations?.Resurs
                                                ?.BO_RESURS_ID +
                                              ')'}
                                          </EDTypography>
                                          <EDBox
                                            maxWidth={'40%'}
                                            textAlign={'end'}
                                            fontSize={'small'}
                                          >
                                            {
                                              getVarmeOption(
                                                aktBokrub?.VARME_STANDARD
                                              )?.name
                                            }
                                          </EDBox>
                                        </EDBox>
                                      }
                                    >
                                      <EDAutoCompleteEdit<IVarmeOption>
                                        hideClear
                                        fullWidth
                                        label={'Värmeinställning'}
                                        options={varmeInstallningarOptions}
                                        getOptionLabel={option => option?.name}
                                        value={getVarmeOption(
                                          aktBokrub?.VARME_STANDARD
                                        )}
                                        onChange={option => {
                                          formContext?.update([
                                            {
                                              operation:
                                                aktBokrub.id.startsWith(
                                                  NEWLY_ADDED_ID_PREFIX_FOR_UPDATE
                                                )
                                                  ? 'Add_Values'
                                                  : 'Update_Values',
                                              associationName: 'AktBokRubrik',
                                              id: aktBokrub.id,
                                              values: {
                                                VARME_STANDARD:
                                                  option?.value ?? 20,
                                              },
                                            },
                                          ]);
                                        }}
                                        disabled={
                                          !userCanEditOvrigAktGudsAktOchNoteringBooking
                                        }
                                      ></EDAutoCompleteEdit>
                                      {getVarmeOption(aktBokrub?.VARME_STANDARD)
                                        ?.name === 'Valfri temperatur' && (
                                        <EDCounter
                                          label="Temperatur"
                                          warning={varmeWarning(
                                            aktBokrub?.VARME_STANDARD
                                          )}
                                          helperText={
                                            varmeWarning(
                                              aktBokrub?.VARME_STANDARD
                                            )
                                              ? varmeHelperText(
                                                  aktBokrub?.VARME_STANDARD
                                                )
                                              : ''
                                          }
                                          value={aktBokrub?.VARME_STANDARD}
                                          onChange={value => {
                                            formContext?.update([
                                              {
                                                operation:
                                                  aktBokrub.id.startsWith(
                                                    NEWLY_ADDED_ID_PREFIX_FOR_UPDATE
                                                  )
                                                    ? 'Add_Values'
                                                    : 'Update_Values',
                                                associationName: 'AktBokRubrik',
                                                id: aktBokrub.id,
                                                values: {
                                                  VARME_STANDARD: value,
                                                },
                                              },
                                            ]);
                                          }}
                                        ></EDCounter>
                                      )}
                                    </EDExpansionPanel>
                                  );
                                } else {
                                  return (
                                    <EDBox
                                      paddingBottom={'16px'}
                                      key={aktBokrub.id}
                                      display={'flex'}
                                      alignItems={'center'}
                                      justifyContent={'space-between'}
                                      paddingTop={'10px'}
                                      paddingLeft={'16px'}
                                      paddingRight={'16px'}
                                      borderBottom={'0.5px solid grey'}
                                    >
                                      <EDTypography
                                        maxWidth={'40%'}
                                        color={'GrayText'}
                                        fontWeight={'bold'}
                                      >
                                        {aktBokrub.FRANTID}
                                        {'-'}
                                        {aktBokrub.TILLTID}{' '}
                                        <EDBox
                                          display={'inline-block'}
                                          paddingRight={'5px'}
                                        ></EDBox>
                                        {aktBokrub.RESURS_NAMN}
                                        {'    '}
                                        {'(' +
                                          aktBokrub?._Associations?.Resurs
                                            ?.BO_RESURS_ID +
                                          ')'}
                                      </EDTypography>
                                      <EDBox
                                        maxWidth={'40%'}
                                        textAlign={'end'}
                                        fontSize={'small'}
                                      >
                                        {
                                          getVarmeOption(
                                            aktBokrub?.VARME_STANDARD
                                          )?.name
                                        }
                                      </EDBox>
                                    </EDBox>
                                  );
                                }
                              } else return <EDBox key={aktBokrub.id}></EDBox>;
                            }
                          )}
                        </ObjektVyKort>
                      </ObjektVyKolumn>
                    </ObjektVyKolumner>
                  </ObjektVySida>
                  <ObjektVySida
                    data-testid={'Repeterade aktiviteter'}
                    sidNr={5}
                    caption="Repeterade aktiviteter"
                    collectionName={aktivitetModel.CollectionName}
                    hidden={
                      !(
                        formContext?.formState.currentValues
                          ?.AntalRepeteradeAktiviteter > 0
                      )
                    }
                  >
                    {formContext?.formState.currentValues
                      ?.AntalRepeteradeAktiviteter > 0 && (
                      <AssociationList
                        collectionName="BOAktivitet"
                        ownId={nodeData?.id ?? null}
                        associationName="RepeteradeAktiviteter"
                        config={customrepCols}
                      />
                    )}
                  </ObjektVySida>
                </ObjektVy>
              </XBridgeDubbelbokCheck>
            </>
          );
        }}
      </BusinessDataFormContext.Consumer>
    </BusinessDataForm>
  );
};

export const aktivitet = collectionCompToObjektVy(AktivitetVy);
